<template>
  <div class="custom-list" :class="{ 'is-loading': isLoading || !view }">
    <div
      v-if="!isCustomNotFoundVisible && (isLoading || !view)"
      class="progress-icon dark-color center"
    ></div>
    <div v-if="!isLoading && isCustomNotFoundVisible">
      <PageNotFound :isBackButtonVisible="false" />
    </div>
    <div v-show="!isCustomNotFoundVisible && !isLoading && view">
      <div
        class="group-actions"
        v-show="
          showGroupAction && !htmlViewerModal.isHtmlViewerVisible && !isLoading
        "
      >
        <div class="inner">
          <p>
            <span class="selected-items">{{ selectedItemCount }}</span>
            <span class="selected-items-label">Ausgewählte Einträge</span>
          </p>
          <ul class="toolbar">
            <li
              class="item share"
              @click="shareSelectedItems()"
              v-show="isItemSelected"
              v-b-tooltip.hover
              title="Teilen"
            >
              <a class="link">share</a>
            </li>

            <li
              class="item download"
              @click="exportSelectedItems()"
              v-show="isItemSelected"
              v-b-tooltip.hover
              title="Herunterladen"
            >
              <a class="link">download</a>
            </li>
            <li
              v-if="database.access_level !== 'read' && !database.add_only"
              class="item delete"
              @click="deleteSelectedItems()"
              v-b-tooltip.hover
              title="Löschen"
            >
              <a class="link">delete</a>
            </li>
          </ul>
        </div>
        <div
          v-show="items.length > 1 && !isAddOptionsVisible"
          class="select-all-wrapper"
        >
          <button
            class="btn-select-all"
            :disabled="allItemsSelected"
            @click="selectAll()"
          >
            Alle auswählen
          </button>
          <button class="btn-select-all" @click="unSelectAll()">
            Alle abwählen
          </button>
        </div>
      </div>
      <modal-box
        class="modal-window"
        :title="modalBox.title"
        :message="modalBox.msg"
        :buttonCaption="modalBox.btnCaption"
        v-if="isModalVisible"
        @close="hideModalBox"
      />
      <modal-share
        class="modal-window"
        v-if="shareSetting.isShareModalVisible"
        :artefact="this.shareSetting.artefact"
        :description="this.shareSetting.description"
        :attachment="this.shareSetting.attachment"
        @close="closeModal"
      />
      <div class="no-data" v-show="noData && !isLoading">
        <!-- If no content available for the table -->
        <div
          v-show="noData && !isLoading"
          dz-preview-wrapper
          class="dz-no-content-message"
        >
          <h3>Keine {{ database.caption }}-Daten vorhanden</h3>
          <p v-if="database.access_level != 'read'">
            Klicken Sie hier, um einen neuen Datensatz hinzufügen.
          </p>
          <img
            v-if="database.access_level != 'read'"
            src="../assets/img/add.svg"
            class="no-data"
            @click="togglePlusBtn"
          />
          <img
            v-else
            src="../assets/img/nodata.svg"
            class="no-data default-cursor"
            @click="togglePlusBtn"
          />
        </div>
      </div>
      <div
        ref="customList"
        class="customdropzone"
        :class="{
          'full-height': database.access_level == 'read',
          'customdropzone-icon-view': view == 'icon' && startRender,
          'pagination-enabled': pagination.isEnabled,
        }"
        v-if="view == 'icon' && startRender"
        v-show="!isLoading"
        @scroll.passive="onCustomListScrolled"
      >
        <div
          v-if="isCustomTableLoading"
          class="progress-icon dark-color table-loader"
        ></div>
        <div
          v-for="(e, i) in filteredItems"
          :key="e[getSqlKey('id')]"
          :index="parseInt(i) + 1"
          class="dz-preview dz-file-preview"
          :class="{
            checked: isSelectedItem(e[getSqlKey('id')]),
            loading: e.loading,
          }"
          :style="{ zoom: getZoom() }"
          @mouseenter="elOnHoverIdx = e[getSqlKey('id')]"
          @mouseleave="hideActionDropdown(), (elOnHoverIdx = null)"
          v-show="!isCustomTableLoading"
        >
          <div dz-preview-wrapper class="dz-preview-wrapper">
            <div class="dz-image">
              <!-- <div class="data-dz-thumbnail-bg-overlay loading" v-if="e.loading">
            </div> -->
              <div
                data-dz-thumbnail-bg-overlay
                class="data-dz-thumbnail-bg-overlay"
                :class="{
                  loading: e.loading,
                  'on-hover': elOnHoverIdx === e[getSqlKey('id')],
                }"
              >
                <ul class="tools">
                  <li class="share" title="Teilen" @click="shareItem(e)">
                    <a>share</a>
                  </li>
                  <li
                    class="log"
                    title="Log"
                    @click="openCustomDBLogs(e[getSqlKey('id')])"
                  >
                    <a>log</a>
                  </li>
                  <li
                    v-if="database.access_level != 'read'"
                    title="Duplizieren"
                    @click="duplicateItem(e)"
                    class="icon-copy"
                  >
                    <a>copy</a>
                  </li>
                  <li class="download" title="Download" @click="exportItem(e)">
                    <a>
                      <span class="accessibility">Download xls</span>
                    </a>
                  </li>
                  <li
                    v-if="
                      database.access_level !== 'read' && !database.add_only
                    "
                    data-dz-delete
                    class="delete"
                    title="Löschen"
                    @click="deleteItem(e)"
                  >
                    <a>delete</a>
                  </li>
                  <li
                    class="dropdown-toggle"
                    title="Mehr"
                    @click="toggleActionDropdown()"
                  >
                    <a>mehr</a>
                  </li>
                </ul>
                <div class="checker">
                  <span
                    data-dz-checkbox
                    :class="{ checked: isSelectedItem(e[getSqlKey('id')]) }"
                  >
                    <input
                      type="checkbox"
                      @click="checkSelectedItemOnClick($event, e)"
                    />
                  </span>
                </div>
                <router-link
                  class="btn-oval"
                  v-if="!isActionDropdownVisible"
                  :to="{
                    path: '/',
                    query: {
                      section: 'data',
                      database: database.name,
                      item: e[getSqlKey('id')],
                    },
                  }"
                >
                  Anzeigen
                </router-link>
                <a
                  v-if="isSchemaWithItemLink && hasItemLink(e)"
                  class="btn-oval item-link"
                  @click="goToLink(e)"
                >
                  zum Link
                </a>
              </div>
            </div>
            <div class="progress-icon" v-if="e.loading"></div>

            <!-- Dropdown menu for actions-->
            <div class="dropdown action-dropdown icon-view">
              <ul
                v-if="
                  isActionDropdownVisible && elOnHoverIdx === e[getSqlKey('id')]
                "
                @mouseleave="hideActionDropdown()"
              >
                <li
                  v-for="a in actionList"
                  :key="a.id"
                  @click="runAction(a.id, e[getSqlKey('id')])"
                  class="dropdown-action-item"
                >
                  <div
                    class="loadingoverlay"
                    v-if="isDatabaseDropDownLoading(a.id, e[getSqlKey('id')])"
                  >
                    <div class="custom-table-progress-icon"></div>
                  </div>
                  {{ a.name }}
                </li>
                <li
                  class="create-new-action"
                  v-if="userHasPermissionToAddFlow"
                  @click="createNewAction(e[getSqlKey('id')])"
                >
                  <i class="far fa-plus-square"></i>Neue Aktion hinzufügen
                </li>
              </ul>
            </div>
            <!-- More components of dropzone preview-->
            <div class="dz-progress">
              <span class="dz-upload" data-dz-uploadprogress></span>
            </div>
            <div class="dz-details">
              <div
                class="highlighted-item"
                v-for="(value, key, index) in displayParam(e)"
                :key="key"
                :class="{ first: index === 0 }"
              >
                <div v-if="isCorrectElementType(key, 'linktodb')">
                  {{ itemsAsObjects[key] }} :
                  <span v-html="generateLink(key, value)"></span>
                </div>
                <div
                  class="list"
                  v-else-if="isCorrectElementType(key, 'freecontent')"
                >
                  {{ itemsAsObjects[key] }} :
                  <img
                    class="object-list-icon"
                    src="../assets/img/object-list.svg"
                    alt="list"
                  />
                </div>
                <div
                  v-else-if="
                    !isList(value) && typeof formatValues(value) != 'number'
                  "
                >
                  {{ itemsAsObjects[key] }} : {{ formatValues(value) }}
                </div>
                <div
                  v-else-if="
                    !isList(value) && typeof formatValues(value) == 'number'
                  "
                  class="d-flex"
                >
                  {{ itemsAsObjects[key] }} :
                  <NumberComponent
                    class="ms-2"
                    :passedNumberValue="formatValues(value) || 0"
                    :decimalValuesCount="getFormattedElementToFixedValue(key)"
                    :showAsFixedNumber="true"
                  />
                </div>

                <div v-else class="list">
                  {{ itemsAsObjects[key] }} :
                  <img
                    class="object-list-icon"
                    src="../assets/img/object-list.svg"
                    alt="list"
                  />
                </div>
              </div>
              <div
                class="highlighted-item"
                v-if="e.hasOwnProperty('modified') && e.modified != null"
              >
                Geändert am : {{ new Date(e.modified).toLocaleString() }}
              </div>
              <div
                class="highlighted-item"
                v-if="
                  e.hasOwnProperty(getSqlKey('created')) &&
                  e[getSqlKey('created')] != null
                "
              >
                Erstellt am :
                {{ formatDate(e[getSqlKey('created')]) }}
              </div>
            </div>
            <div class="dz-error-message">
              <span data-dz-errormessage></span>
            </div>
            <div class="dz-success-mark">
              <i class="fa fa-check"></i>
            </div>
            <div class="dz-error-mark">
              <i class="fa fa-close"></i>
            </div>
          </div>
        </div>
        <div
          v-if="dropzoneOptions.isLoading && !noData"
          class="dz-preview dz-file-preview"
          :style="{ zoom: getZoom() }"
          style="zoom; z-index: 0;"
        >
          <div dz-preview-wrapper class="dz-preview-wrapper">
            <div class="container"></div>
            <div class="dz-image">
              <div
                data-dz-thumbnail-bg
                class="data-dz-thumbnail-bg loading"
                style="height: 100%"
              >
                <div
                  data-dz-thumbnail-bg-overlay
                  class="data-dz-thumbnail-bg-overlay loading"
                >
                  <div class="progress-icon"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- white space -->
        <div
          class="white-space"
          :class="{ 'extra-height': showGroupAction }"
        ></div>
      </div>
      <div
        style="margin-top: 10px"
        class="load-more"
        v-if="isPaginationVisible() && view == 'icon' && startRender"
      >
        <button @click="appendRows">
          <i class="fa fa-arrow-down me-2"></i>
          <span>Mehr anzeigen</span>
          <div
            v-if="pagination.isFetchingIems"
            class="custom-table-progress-icon"
          ></div>
        </button>
      </div>
      <div
        class="listwrapper"
        v-if="view == 'list' && startRender"
        v-show="!isLoading"
      >
        <div
          v-if="isCustomTableLoading"
          class="progress-icon dark-color table-loader"
          :style="{ marginTop: getCustomLoaderPostion() }"
        ></div>

        <CustomTable
          v-if="view == 'list' && startRender && !isCustomTableLoading"
          ref="customTableRef"
          tableid="newtab"
          :dataHeader="headersList"
          :colWidth="getHeaderWidth()"
          :dataList="filteredItems"
          :displayParam="displayParam"
          @onDragOrResize="updateOnDragOrResize"
          :isCheckBoxEnabled="true"
          @onCheckBoxClick="checkSelectedItemOnClick"
          :isCheckboxChecked="isCheckboxChecked"
          :getSqlKey="getSqlKey"
          :getHeaderContent="headerNameLableObject"
          :variableTableHeight="getTableHeight"
          :isCorrectElementType="isCorrectElementType"
          :generateLink="generateLink"
          :getFormattedElementToFixedValue="getFormattedElementToFixedValue"
        >
          <template #default="loopitems">
            <div class="actioncontainer">
              <ul>
                <li
                  class="show-btn"
                  :class="{ 'move-left': database.access_level == 'read' }"
                >
                  <!-- v-show="!dropdownOpen" -->
                  <router-link
                    :to="{
                      path: '/',
                      query: {
                        section: 'data',
                        database: database.name,
                        item: loopitems.loopitems.item[getSqlKey('id')],
                      },
                    }"
                    v-if="database.type !== 'timetrigger'"
                  >
                    Anzeigen
                  </router-link>
                  <a
                    v-else
                    @click.prevent="
                      onTimeTriggerEditItem(loopitems.loopitems.item)
                    "
                  >
                    Anzeigen
                  </a>
                </li>

                <li title="Teilen" @click="shareItem(loopitems.loopitems.item)">
                  <i class="fa fa-share"> </i>
                </li>

                <li
                  v-if="database.access_level != 'read'"
                  title="Duplizieren"
                  @click="duplicateItem(loopitems.loopitems.item)"
                >
                  <i class="far fa-copy"></i>
                </li>

                <li @click="exportItem(loopitems.loopitems.item, true)">
                  <i class="fa fa-download"> </i>
                </li>

                <li
                  v-if="database.access_level !== 'read' && !database.add_only"
                  title="Löschen"
                  @click="deleteItem(loopitems.loopitems.item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </li>
                <li>
                  <generalDropdown
                    :isCaretVisible="false"
                    :uniqueReferenceId="
                      'customTableDropDownRef' + loopitems.loopitems.index
                    "
                    :ref="'customListDropdownRef' + loopitems.loopitems.index"
                  >
                    <template v-slot:iconContainer>
                      <li title="Mehr" class="dropdown-toggle">
                        <!-- @click="toggleActionDropdown()" -->
                        <img
                          class="dropdown-btn"
                          src="../assets/img/more-icon.svg"
                          @click="
                            loopitems.loopitems.onDropdownClick(
                              $event,
                              loopitems.loopitems.index
                            )
                          "
                        />
                      </li>
                    </template>

                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="a in actionList"
                        :key="a.id"
                        @click.native.capture.stop.prevent="
                          runAction(a.id, loopitems.loopitems.item.id)
                        "
                        class="dropdown-action-item"
                      >
                        <div
                          v-if="
                            isDatabaseDropDownLoading(
                              a.id,
                              loopitems.loopitems.item.id
                            )
                          "
                          class="loadingoverlay"
                        >
                          <div class="custom-table-progress-icon"></div>
                        </div>
                        {{ a.name }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="userHasPermissionToAddFlow"
                        class="create-new-action"
                        @click="createNewAction(loopitems.loopitems.item.id)"
                      >
                        <i class="far fa-plus-square"></i>Neue Aktion hinzufügen
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                </li>
              </ul>
            </div>
          </template>
          <template #loadmore>
            <div class="load-more" v-if="isPaginationVisible()">
              <button @click="appendRows">
                <i class="fa fa-arrow-down me-2"></i>
                <span>Mehr anzeigen</span>
                <div
                  v-if="pagination.isFetchingIems"
                  class="custom-table-progress-icon"
                ></div>
              </button>
            </div>
          </template>
        </CustomTable>
      </div>
      <CustomDatabaseSettings
        ref="settings"
        v-if="settingsIsVisible"
        :customHighlightedItems="customData"
        :dataSchema="dataSchema"
        @close="hideSettings()"
        @setItemHighlight="setItemHighlight"
        @setHighlightItemOptions="onSetHighlightItemOptions"
        @setItemHighlightOnDrop="setItemHighlightOnDrop"
      />
      <htmlViewer
        v-if="htmlViewerModal.isHtmlViewerVisible"
        @close="closeHtmlViewer"
        :myHtml="htmlViewerModal.myHtml"
      >
      </htmlViewer>
      <CustomDetails
        v-if="isCustomDetailsVisible"
        @close="toggleCustomDetails"
        :selectedItem="selectedItem"
        :database="database"
        :isAddingNewItem="isAddingNewItem"
        :dataSchema="dataSchema"
        :isCopyDatabaseItem="isCopyDatabaseItem"
        @toggleCopyDatabaseItem="toggleCopyDatabaseItem"
        ref="customDetailsRef"
      ></CustomDetails>
      <div class="kanban-board-wrapper" v-if="view == 'board' && startRender">
        <KanbanBoard
          v-show="!isLoading"
          :class="{ 'full-height': database.access_level == 'read' }"
          :stages="statusAsArray"
          :blocks="filteredItems"
          :keyTranslations="itemsAsObjects"
          :title="dataSchema.length ? dataSchema[0].name : null"
          :dataSchema="dataSchema"
          :database="database"
          :isLoading="isLoading"
          @saveItems="saveItems"
          @goTo="goTo"
          @removeItem="deleteItem"
          @exportItem="exportItem"
          @shareItem="shareItem"
        ></KanbanBoard>
        <button
          @click="scrollToTopOfLoadProfileList()"
          v-if="isScrollToTopButtonVisible"
          class="go-to-top"
          title="Zum start scrollen"
          :class="{
            'group-action-open':
              showGroupAction &&
              !htmlViewerModal.isHtmlViewerVisible &&
              !isLoading,
          }"
        >
          <span></span>
        </button>
      </div>
      <div class="custom-db-log-modal">
        <updates
          v-if="isShowupdate"
          :updates="logs"
          dbType="custom"
          @close="closeCustomDBLogs"
        />
      </div>

      <removeConfirmationModal
        v-if="confirmationModal.isVisible"
        class="modal-window"
        :id="confirmationModal.id"
        :name="confirmationModal.name"
        :resourceType="confirmationModal.resourceType"
        :actionType="confirmationModal.actionType"
        @close="closeConfirmationModal"
        @confirmRemove="confirmRemoveItem"
      />
      <div v-if="database.type == 'timetrigger'">
        <ManageTimeTriggerModal
          v-if="manageTimeTriggerModal.visible"
          :mode="manageTimeTriggerModal.mode"
          :editData="manageTimeTriggerModal.data"
          @toggleTimeTriggerModal="toggleTimeTriggerModal"
          :databaseName="database.name"
          :isCopyDatabaseItem="isCopyDatabaseItem"
          @refreshData="!isRefreshing && refreshTable()"
          @toggleCopyDatabaseItem="toggleCopyDatabaseItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ModalShare from './modals/ModalShare.vue';
import ModalBox from './modals/ModalBox.vue';
import htmlViewer from './modals/htmlViewer.vue';
import CustomDetails from './CustomDetails.vue';
import * as JSZip from 'jszip';
import KanbanBoard from './Board.vue';
import CustomDatabaseSettings from './CustomDatabaseSettings.vue';
import NumberComponent from './widgets/NumberComponent.vue';
import removeConfirmationModal from './modals/removeConfirmModal.vue';
import {
  updateDatabaseItemKey,
  updateTableSchema,
} from '../services/userTable.js';

//amplify
import { components } from 'aws-amplify-vue';
import Store from '../store/store';
import { Auth } from 'aws-amplify';
import Updates from './Updates.vue';

import {
  debouncer,
  isObjectType,
  getFlowLastId,
  mergeArray,
  jsonParser,
  getDataApiVersion,
} from '../utils/helpers';
import GeneralDropdown from './core/general-dropdown.vue';
import moment from 'moment';
import CustomTable from './CustomTable';
import { runFlowById } from '../services/workflow.service';
import { getDataBaseTableSchema } from '../services/userTable';
import {
  getCustomDatabaseItems,
  getCustomDatabaseItem,
} from '../services/customdb.service';
import ManageTimeTriggerModal from './modals/ManageTimeTriggerModal.vue';
import PageNotFound from './PageNotFound.vue';
import { mapGetters } from 'vuex';
import { getLogs } from '../services/axios/data.api';

export default {
  name: 'CustomListFullScreen',

  data() {
    return {
      dropdownOpen: false,
      id: '',
      name: '',
      pictures: {
        parser: '../assets/img/file.png',
      },
      items: [],
      modalBox: {
        showAfterQueueIsDone: false,
        title: '',
        msg: [],
        btnCaption: 'Schliessen',
      },
      shareSetting: {
        isShareModalVisible: false,
        artefact: '',
        description: '',
        attachment: null,
      },
      reportViewer: {
        isReportViewerVisible: false,
        title: '',
        json: '',
        btnCaption: '',
      },
      htmlViewerModal: {
        isHtmlViewerVisible: false,
        myHtml: null,
      },
      isComparatorVisible: false,
      isCustomDetailsVisible: false,
      lastTokenRefresh: null,
      settingsIsVisible: false,
      isGroupShowMoreVisible: false,
      isActionDropdownVisible: false,
      isGroupActionVisible: false,
      isAddOptionsVisible: false,
      isUploadFileVisible: false,
      isLoading: false,
      lastID: null,
      isRefreshing: null,
      hideTimer: null,
      files: [],
      fileUpdateInterval: null,
      filterItemsAs: null,
      operationRunningPlaceholder: null,
      showTimeFilterOptions: false,
      filterTime: 1462277206,
      isAddFilterVisible: false,
      isEditFilterVisible: false,
      isClickOutsideDelayed: true,
      activeFilter: null,
      filterAttr: null,
      filterOpperand: null,
      filterVal: null,
      filters: [],
      filterOptions: [
        {
          label: 'beinhaltet',
          opperand: '.includes(',
          visibility: ['all', 'number', 'radio', 'checkbox'],
        },
        {
          label: 'beinhaltet nicht',
          opperand: '!.includes(',
          visibility: ['all', 'number', 'radio', 'checkbox'],
        },
        {
          label: 'ist genau',
          opperand: '==',
          visibility: ['all', 'number', 'datetime'],
        },
        {
          label: 'ist nicht',
          opperand: '!=',
          visibility: ['all', 'number', 'datetime'],
        },
        {
          label: 'ist grösser',
          opperand: '>',
          visibility: ['number', 'datetime'],
        },
        {
          label: 'ist grösser oder gleich',
          opperand: '>=',
          visibility: ['number', 'datetime'],
        },
        {
          label: 'ist kleiner',
          opperand: '<',
          visibility: ['number', 'datetime'],
        },
        {
          label: 'ist kleiner oder gleich',
          opperand: '<=',
          visibility: ['number', 'datetime'],
        },
      ],
      defaultFilterSchema: [
        {
          name: 'id',
          label: 'Id',
        },
        {
          name: 'created',
          label: 'Erstellt am',
          type: 'datetime',
        },
        {
          name: 'updated',
          label: 'Aktualisiert am',
          type: 'datetime',
        },
      ],
      timeFilterOptions: [
        {
          caption: '1 Stunde',
          value: 3600000,
          selected: false,
        },
        {
          caption: '1 Tag',
          value: 86400000,
          selected: false,
        },
        {
          caption: '1 Woche',
          value: 604800000,
          selected: false,
        },
        {
          caption: '1 Monat',
          value: 2419200000,
          selected: false,
        },
      ],
      zoom: 70,
      parserEndPoint: process.env.VUE_APP_LOAD_PARSER_API,
      tsOperationsEndPoint: process.env.VUE_APP_TS_CALCULATION_API,
      emailEndPoint: process.env.VUE_APP_E_MAIL_API,
      dropzoneOptions: {
        previewTemplate: this.template(),
        isLoading: false,
        filesToProcess: null,
        remainingFilesCount: null,
        timeout: 100000,
        renameFilename: function (filename, file) {
          return (file.renameFilename = new Date().getTime() + '_' + filename);
        },
      },
      awss3: {
        signingURL: (f) => {
          /* return "http://127.0.0.1:1333/get-signed-url/" + encodeURIComponent(f.renameFilename); */
          return (
            process.env.VUE_APP_DATA_API +
            '/get-signed-url/' +
            encodeURIComponent(f.renameFilename)
          );
        },
        headers: {
          Authorization: null,
        },
        sendFileToServer: false,
      },
      selectedItem: null,
      isAddingNewItem: null,
      isHighlightOptionsVisible: false,
      customHighlightedItems: [],
      view: null,
      highlightedViewIcon: null,
      elOnHoverIdx: null,
      highlightItems: {},
      dataSchema: [],
      startRender: true,
      isChangeViewActive: false,
      isShowupdate: false,
      logs: [],
      lastSelectedItemIdForShiftSelect: null,
      selectedItemIds: [],
      isScrollToTopButtonVisible: false,
      headersList: [],
      customData: [],
      headerNameLableObject: {},
      debounceTimer: null,
      debouncedHighlightedKeys: [],
      isCustomTableLoading: false,
      isActionDropDownLoading: {
        itemID: null,
        actionID: null,
      },
      highlightedKeysCalledInApi: [],
      itemToDelete: null,
      confirmationModal: {
        id: null,
        name: null,
        actionType: 'remove',
        isVisible: false,
        resourceType: 'item',
        isMultipleItems: false,
      },
      activeFilterId: null,
      manageTimeTriggerModal: {
        visible: false,
        mode: null,
        data: null,
      },
      isCopyDatabaseItem: false,
      pagination: {
        limit: 30,
        isEnabled: true,
        lastEvaluatedKey: '',
        isFetchingIems: false,
      },
      isCustomNotFoundVisible: false,
    };
  },
  props: {
    database: Object,
    itemID: String,
    activeDatabase: String,
    isNewDataTypeModalVisible: Boolean,
  },
  methods: {
    toggleNotFound(bool) {
      this.isCustomNotFoundVisible = bool;
    },
    toggleCopyDatabaseItem(bool) {
      this.isCopyDatabaseItem = bool;
    },
    duplicateItem(item) {
      this.toggleCopyDatabaseItem(true);

      if (this.database.type === 'timetrigger') {
        this.onTimeTriggerEditItem(item);
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'data',
            database: this.database.name,
            item: item[this.getSqlKey('id')],
          },
        });
      }
    },
    async onTimeTriggerEditItem(item) {
      this.toggleTimeTriggerModal(true, 'edit', {
        databaseID: this.database.name,
        itemID: item.id,
      });
    },
    toggleTimeTriggerModal(visible, mode, data) {
      if (!visible) {
        this.toggleCopyDatabaseItem(false);
      }
      this.manageTimeTriggerModal = {
        visible: visible,
        mode: mode,
        data: data,
      };
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    isDatabaseDropDownLoading(actionid, itemid) {
      return (
        this.isActionDropDownLoading.itemID !== null &&
        this.isActionDropDownLoading.actionID !== null &&
        this.isActionDropDownLoading.itemID == itemid &&
        this.isActionDropDownLoading.actionID == actionid
      );
    },
    getCustomLoaderPostion() {
      return window.innerHeight / 2 - (120 + 140 + 38) + 'px';
    },
    appendRows() {
      if (this.isPaginationVisible() && !this.pagination.isFetchingIems) {
        this.getAllItems(false);
      }
    },
    isPaginationVisible() {
      return (
        this.pagination.isEnabled &&
        this.pagination.lastEvaluatedKey !== null &&
        !this.noData
      );
    },
    getObjectData(header, elementType) {
      if (this.database.schema) {
        const dataObject = JSON.parse(this.database.schema).find(
          (el) => el.name.trim() === header.trim()
        );
        if (dataObject && dataObject.type && dataObject.type === elementType) {
          return { isCorrectType: true, data: dataObject };
        }
      }
      return { isCorrectType: false, data: {} };
    },
    isCorrectElementType(header, elementType) {
      const { isCorrectType } = this.getObjectData(header, elementType);
      return isCorrectType;
    },
    getElementData(header, elementType) {
      const { data } = this.getObjectData(header, elementType);
      return data;
    },

    generateLink(header, listData) {
      const { data, isCorrectType } = this.getObjectData(header, 'linktodb');
      if (isCorrectType) {
        const dataItem = listData ? listData : data.value;
        const domain = window.location.origin;
        const url = `${domain}/#/?section=data&database=${data.selectedDatabaseID}&item=${dataItem}`;
        return `<a href="${url}" target="_blank" style="text-decoration: underline; color: #5f697a">${data.name}</a>`;
      }
    },
    debounceFunction(func, timeout = 1500, variableName) {
      debouncer(func, timeout, this, variableName);
    },

    isCheckboxChecked(item) {
      return this.isSelectedItem(item[this.getSqlKey('id')]);
    },
    getHeaderWidth() {
      if (
        this.userSettings &&
        this.userSettings.customDatabaseSchema &&
        this.userSettings.customDatabaseSchema[this.database.name] !==
          undefined &&
        this.userSettings.customDatabaseSchema[this.database.name].colWidth !==
          undefined
      ) {
        return this.userSettings.customDatabaseSchema[this.database.name]
          .colWidth;
      } else {
        return {};
      }
    },
    async updateSettings(updatedHeadersWidth, updatedHeaders) {
      const updatedUserSettings = {
        ...this.userSettings,
        customDatabaseSchema: {
          ...this.userSettings['customDatabaseSchema'],
          [this.database.name]: {
            ...this.userSettings['customDatabaseSchema'][this.database.name],
            colWidth: updatedHeadersWidth,
            colPosition: [...new Set(updatedHeaders)],
          },
        },
      };

      await this.$store.dispatch('updateUserSettings', updatedUserSettings);
    },
    async updateOnDragOrResize(data) {
      this.setCustomHighlightedItems(data.updatedHeaders);
      this.headersList = data.updatedHeaders;

      this.debounceFunction(() => {
        this.updateSettings(data.updatedHeadersWidth, data.updatedHeaders);
      });
    },
    getSqlKey(key) {
      if (this.database.sql_cdls && JSON.parse(this.database.sql_cdls)[key]) {
        return JSON.parse(this.database.sql_cdls)[key];
      } else return key;
    },
    updateHeaderData() {
      let headerData = [...this.dataSchema]
        .filter((ele) => ele.highlight === true)
        .map((el) => el.name);

      if (headerData.length === 0) {
        headerData = this.dataSchema
          .map((data, index) => {
            if (index < 10) {
              data.highlight = true;
            }
            return data.name;
          })
          .slice(0, 10);

        const data = this.dataSchema.map((e) => ({
          name: e.name,
          label: e.label,
          selected: e.highlight,
        }));
        this.customData = data;
        this.customHighlightedItems = data;
      } else {
        this.customData = this.customHighlightedItems;
      }

      this.headersList = headerData;

      let columnWidth;

      if (
        this.userSettings &&
        this.userSettings.customDatabaseSchema &&
        this.userSettings.customDatabaseSchema[this.database.name] !==
          undefined &&
        this.userSettings.customDatabaseSchema[this.database.name].colWidth !==
          undefined
      ) {
        columnWidth =
          this.userSettings['customDatabaseSchema'][this.database.name]
            .colWidth;
      } else {
        columnWidth = {};
      }

      this.debounceFunction(
        () => {
          this.updateSettings(columnWidth, headerData);
        },
        1500,
        'customSettingsDebounce'
      );

      if (!this.isCustomHighlighting) {
        this.getSchema();
        this.setHighlightItemOptions();
      }
    },
    async fetchHighlightItemData() {
      if (this.debouncedHighlightedKeys.length) {
        try {
          const filteredKeyArray = [...this.debouncedHighlightedKeys].filter(
            (el) => !this.highlightedKeysCalledInApi.includes(el)
          );

          this.highlightedKeysCalledInApi = [
            ...this.highlightedKeysCalledInApi,
            ...this.debouncedHighlightedKeys,
          ];

          let finalParam = '';

          if (this.pagination.lastEvaluatedKey === '') {
            finalParam = `&limit=${this.pagination.limit}`;
          } else if (this.pagination.lastEvaluatedKey !== null) {
            finalParam = `&end=${encodeURIComponent(
              this.pagination.lastEvaluatedKey
            )}`;
          }

          const params =
            filteredKeyArray.length > 0
              ? filteredKeyArray.join()
              : this.debouncedHighlightedKeys.join();
          const response = await getCustomDatabaseItems(
            this.tableName,
            `?keys=${params}${finalParam}`
          );

          if (
            response.status === 200 &&
            response.data &&
            response.data.hasOwnProperty('items') &&
            response.data.hasOwnProperty('lastEvaluatedKey') &&
            Array.isArray(response.data.items)
          ) {
            this.debouncedHighlightedKeys = [];
            this.pagination.lastEvaluatedKey = response.data.lastEvaluatedKey;
            const mergedArray = mergeArray(
              this.items,
              response.data.items,
              'id'
            );
            this.items = mergedArray;
            this.isCustomTableLoading = false;
          }
        } catch (error) {
          this.isCustomTableLoading = false;
        }
      } else {
        this.isCustomTableLoading = false;
      }
    },
    shouldFetchDataOnHighlight(dataObject) {
      if (
        !dataObject.selected &&
        this.items.some((el) => !el[dataObject.name])
      ) {
        this.isCustomTableLoading = true;
        this.debouncedHighlightedKeys.push(dataObject.name);
        this.debounceFunction(
          () => {
            this.fetchHighlightItemData();
          },
          600,
          'fetchHighlightItemDataDebounceTimeout'
        );
      }
    },
    setItemHighlightOnDrop(
      draggingValue,
      dropingValue,
      hasToAddInLastSelected
    ) {
      this.shouldFetchDataOnHighlight(draggingValue);
      // Get index
      const dragValueIndex = this.dataSchema.findIndex(
        (e) => e.name === draggingValue.name
      );
      const dropValueIndex = this.dataSchema.findIndex(
        (e) => e.name === dropingValue.name
      );

      const dragValueIndexInCustomDataSchema =
        this.customHighlightedItems.findIndex(
          (e) => e.name === draggingValue.name
        );
      const dropValueIndexInCustomDataSchema =
        this.customHighlightedItems.findIndex(
          (e) => e.name === dropingValue.name
        );

      if (draggingValue.selected === false && dropingValue.selected === true) {
        this.dataSchema[dragValueIndex].highlight = true;
        this.customHighlightedItems[
          dragValueIndexInCustomDataSchema
        ].selected = true;
      }

      if (draggingValue.selected === true && dropingValue.selected === false) {
        this.highlightItems = {};
        this.dataSchema[dragValueIndex].highlight = false;
        this.customHighlightedItems[
          dragValueIndexInCustomDataSchema
        ].selected = false;
      }
      // save value
      const dragValue = JSON.parse(
        JSON.stringify(this.dataSchema[dragValueIndex])
      );

      const dragValueAtCustomDataSchema = JSON.parse(
        JSON.stringify(
          this.customHighlightedItems[dragValueIndexInCustomDataSchema]
        )
      );
      // chnage in custome highlighted item
      this.customHighlightedItems.splice(dragValueIndexInCustomDataSchema, 1);
      this.customHighlightedItems.splice(
        hasToAddInLastSelected && dragValueAtCustomDataSchema.selected
          ? dropValueIndexInCustomDataSchema + 1
          : dropValueIndexInCustomDataSchema,
        0,
        dragValueAtCustomDataSchema
      );
      this.dataSchema.splice(dragValueIndex, 1);
      this.dataSchema.splice(dropValueIndex, 0, dragValue);

      this.updateHeaderData();

      this.sortItems();
    },
    template: function () {
      return `
        <div class="dz-preview dz-file-preview">
                <div dz-preview-wrapper class="dz-preview-wrapper">
                    <div class='container'>
                    </div>
                    <div class="dz-image">
                        <div data-dz-thumbnail-bg class="data-dz-thumbnail-bg loading">
                            <div data-dz-thumbnail-bg-overlay class="data-dz-thumbnail-bg-overlay loading">
                              <div class='progress-icon'>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="dz-progress">
                        <span class="dz-upload" data-dz-uploadprogress></span>
                    </div>
                    <div class="dz-details">
                        <h2 class="rename dz-filename" contenteditable="true">
                            <span data-dz-name ></span>
                        </h2>
                    </div>
                    <div class="dz-error-message">
                        <span data-dz-errormessage></span>
                    </div>
                    <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                    <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                </div>
        </div>`;
    },
    selectAll: function () {
      this.selectedItemIds = this.filteredItems.map(
        (item) => item[this.getSqlKey('id')]
      );

      // Update token
      this.checkRefreshToken();
    },
    unSelectAll: function () {
      this.selectedItemIds = [];
    },

    deleteItem(e) {
      if (
        this.database.confirmDelete &&
        JSON.parse(this.database.confirmDelete)
      ) {
        this.confirmationModal = {
          ...this.confirmationModal,
          name: 'Eintrag löschen',
          isVisible: true,
          isMultipleItems: false,
        };
        this.itemToDelete = e;
      } else this.removeItem(e);
    },

    closeConfirmationModal() {
      this.confirmationModal = {
        ...this.confirmationModal,
        name: '',
        isVisible: false,
        isMultipleItems: false,
      };
      this.itemToDelete = null;
    },

    confirmRemoveItem() {
      this.confirmationModal.isMultipleItems
        ? this.removeSelectedItems()
        : this.removeItem(this.itemToDelete);
    },

    async removeItem(e) {
      const time = new Date().getTime();
      const dbItemLog = {
        author: this.user.attributes.sub,
        'time-start': time,
        'time-end': time,
        'context-parent-type': 'database',
        'context-parent-id': null,
        'context-type': 'database-item',
        'context-id': this.database.name,
        'activity-values': {
          'activity-type': 'database-entry-delete',
          edits: [
            {
              'item-id': e[this.getSqlKey('id')],
            },
          ],
        },
      };
      e.loading = true;

      const url = `${process.env.VUE_APP_DATA_API}/user-tables/${
        this.tableName
      }/items/${e[this.getSqlKey('id')]}`;

      const myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');
      try {
        const response = await fetch(url, {
          headers: myHeaders,
          method: 'DELETE',
        });

        if (response.status == 200) {
          this.items = this.items.filter((x) => {
            return x[this.getSqlKey('id')] != e[this.getSqlKey('id')];
          });
        } else if (response.status == 401) this.handleTokenExpired();
        else throw new Error(response.statusText);
      } catch (err) {
        throw new Error(err);
      }
    },

    deleteSelectedItems() {
      if (
        this.database.confirmDelete &&
        JSON.parse(this.database.confirmDelete)
      )
        this.confirmationModal = {
          ...this.confirmationModal,
          name: 'Alle Einträge löschen',
          isVisible: true,
          isMultipleItems: true,
        };
      else this.removeSelectedItems();
    },

    removeSelectedItems: function () {
      var url = process.env.VUE_APP_DATA_API + '/user-tables/';
      url += this.tableName + '/items';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      let ids = this.selectedItems.map((e) => e[this.getSqlKey('id')]);

      this.selectedItems.map((e) => (e.loading = true));

      let payload = {
        id: ids,
      };

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'DELETE',
      })
        .then((response) => {
          if (response.status == 401) this.handleTokenExpired();
          else return response.json();
        })
        .then(() => {
          this.items = this.items.filter((x) => {
            return !ids.includes(x[this.getSqlKey('id')]);
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    updateItem: async function (id) {
      //
      var newItem = await this.getUpdatedItem(id);

      let indx = this.items.indexOf(
        this.items.find(
          (e) => e[this.getSqlKey('id')] == newItem[this.getSqlKey('id')]
        )
      );
      if (indx != -1) {
        this.$set(this.items, indx, newItem);
      } else {
        this.$set(this.items, this.items.length, newItem);
      }

      this.sortItem();
    },

    getUpdatedItem: async function (id) {
      var url =
        process.env.DATA_API_BASE_URL +
        '/' +
        getDataApiVersion(this.tableName) +
        '/user-tables/';
      url += this.tableName + '/items/' + id;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      return await fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then(async (response) => {
          if (response.status == 401) this.handleTokenExpired();
          else return response.json();
        })
        .then(async (element) => {
          // Add selected to element
          return element;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    thumbnail: function (file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove('dz-file-preview');
        ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]');
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.alt = file.name;
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return setTimeout(
          (function () {
            return function () {
              return file.previewElement.classList.add('dz-image-preview');
            };
          })(this),
          1
        );
      }
    },

    attachListener: function (file) {
      var j, len, checkboxElements, removeButton;
      if (file.previewElement) {
        checkboxElements =
          file.previewElement.querySelectorAll('[data-dz-checkbox]');
        for (j = 0, len = checkboxElements.length; j < len; j++) {
          checkboxElements[j].addEventListener(
            'click',
            function () {
              if (this.classList.contains('checked')) {
                this.classList.remove('checked');
                file.previewElement.classList.remove('checked');
              } else {
                this.classList.add('checked');
                file.previewElement.classList.add('checked');
              }
            },
            false
          );
        }
        removeButton = file.previewElement.querySelectorAll('[data-dz-delete]');
        for (j = 0, len = removeButton.length; j < len; j++) {
          removeButton[j].addEventListener(
            'click',
            function () {
              file.previewElement.remove();
            },
            false
          );
        }
      }
    },

    checkSelectedItemOnClick(event, item) {
      const currentItemSelectedIndex = this.filteredItems.findIndex(
        (itemDetails) =>
          itemDetails[this.getSqlKey('id')] ==
            this.lastSelectedItemIdForShiftSelect &&
          this.isSelectedItem(itemDetails[this.getSqlKey('id')])
      );
      if (
        event.shiftKey &&
        currentItemSelectedIndex != -1 &&
        !this.isSelectedItem(item[this.getSqlKey('id')])
      ) {
        this.selectAllItemsBetweenShiftPressed(currentItemSelectedIndex, item);
      } else {
        this.toggleSeletedItem(item[this.getSqlKey('id')]);

        this.lastSelectedItemIdForShiftSelect = item[this.getSqlKey('id')];
      }
      this.$forceUpdate();
    },

    formatNumber(value, unit) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ' + unit;
    },

    refreshTable: async function () {
      this.isRefreshing = true;
      await this.getAllItems().then(() => {
        if (
          this.headersList &&
          this.headersList.length === 0 &&
          (!this.userSettings ||
            !this.userSettings.customDatabaseSchema ||
            this.userSettings.customDatabaseSchema[this.database.name] ===
              undefined ||
            this.userSettings.customDatabaseSchema[this.database.name]
              .colPosition === undefined ||
            this.userSettings.customDatabaseSchema[this.database.name]
              .colPosition.length === 0)
        ) {
          this.headersList = this.displayParamKeys();
        }
      });
      this.isRefreshing = false;
      this.sortItems();
    },
    getItemParams() {
      return new Promise((resolve) => {
        setTimeout(() => {
          const limitParam = `&limit=${this.pagination.limit}`;
          const startParam =
            this.pagination.lastEvaluatedKey !== ''
              ? `&start=${this.pagination.lastEvaluatedKey}`
              : '';
          // Get custom highlighted items
          if (
            this.customHighlightedItems &&
            this.customHighlightedItems.length > 0
          ) {
            const filteredData = [...this.customHighlightedItems].filter(
              (ele) => ele.selected
            );
            let params = '?keys=' + filteredData.map((el) => el.name).join();
            params += limitParam + startParam;
            resolve(params);
          } else {
            // Get default highlighted items
            const schema = JSON.parse(this.database.schema);
            const filteredData = [...schema].filter((ele) => ele.highlight);
            const params = '?keys=' + filteredData.map((el) => el.name).join();

            if (params != '?keys=') resolve(params + limitParam + startParam);
            else resolve(limitParam + startParam);
          }
        }, 200);
      });
    },
    getAllItems: async function (shouldLoad = true) {
      if (!shouldLoad) {
        this.pagination.isFetchingIems = true;
      }
      if (!this.isRefreshing && shouldLoad) {
        this.isLoading = true;
        this.isCustomTableLoading = true;
      }

      try {
        const params = await this.getItemParams();
        const response = await getCustomDatabaseItems(
          this.tableName,
          params,
          true
        );

        if (response.status != 200) {
          return false;
        }

        if (
          response.status === 200 &&
          response.data &&
          response.data.hasOwnProperty('items') &&
          response.data.hasOwnProperty('lastEvaluatedKey') &&
          Array.isArray(response.data.items)
        ) {
          response.data.items.map((e) => (e.loading = false));
          const mergedArray = mergeArray(this.items, response.data.items, 'id');
          this.items = mergedArray;
          this.pagination.lastEvaluatedKey = response.data.lastEvaluatedKey;
          this.isLoading = false;
          this.isCustomTableLoading = false;
          this.pagination.isFetchingIems = false;

          this.sortItems();
          return true;
        }
      } catch (error) {
        this.isLoading = false;
        this.isCustomTableLoading = false;
        this.pagination.isFetchingIems = false;
        if (error && error.hasOwnProperty('status') && error.status === 404) {
          this.toggleNotFound(true);
        }
        throw new Error(error);
        return false;
      }
    },

    showDropZone() {
      this.isAddOptionsVisible = true;
    },

    showAddOptions() {
      clearInterval(this.hideTimer);
      this.isAddOptionsVisible = true;
    },

    closeHtmlViewer() {
      this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', false);

      // Update files every 5 seconds for 30 seconds
      let fileUpdInterval = setInterval(this.updateFiles, 1000);

      setTimeout(() => {
        clearInterval(fileUpdInterval);
      }, 2000);
    },

    hideDropZone() {
      this.$set(this, 'isAddOptionsVisible', false);
    },

    hideAddOptionsWithDelay() {
      this.hideTimer = setTimeout(this.hideAddOptions, 500);
    },

    hideAddOptions() {
      this.isAddOptionsVisible = false;
    },

    hideSettings() {
      this.settingsIsVisible = false;
    },

    showSettings() {
      this.settingsIsVisible = true;
    },
    hideActionDropdown() {
      this.elOnHoverIdx = null;
      this.isActionDropdownVisible = false;
      this.dropdownOpen = false;
    },
    toggleActionDropdown() {
      // For list-view we must toggle the transform property
      if (this.view === 'list') {
        // if dropdown closed toggle css before open dropdown
        if (!this.dropdownOpen) {
          this.dropdownOpen = true;
          setTimeout(() => {
            this.isActionDropdownVisible = !this.isActionDropdownVisible;
          }, 150);
        }
      } else {
        this.isActionDropdownVisible = !this.isActionDropdownVisible;
      }
    },
    toggleGroupAction() {
      this.isGroupActionVisible = !this.isGroupActionVisible;
    },
    toggleGroupShowMore() {
      this.isGroupShowMoreVisible = !this.isGroupShowMoreVisible;
    },
    toggleUploadFile() {
      this.isUploadFileVisible = !this.isUploadFileVisible;
    },
    toggleTimeFilterDropdown() {
      this.showTimeFilterOptions = !this.showTimeFilterOptions;
    },
    togglePlusBtn() {
      // Update token
      this.checkRefreshToken();

      if (this.database.type === 'timetrigger') {
        this.toggleTimeTriggerModal(true, 'add', null);
      } else {
        this.selectedItem = null;
        this.isAddingNewItem = true;
        this.isCustomDetailsVisible = true;
        document.body.classList.add('modal-open');
      }
    },

    toggleUpload() {
      // Set header for signed-url request

      this.refreshSession().then(() => {
        this.awss3.headers.Authorization =
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken;
      });

      this.showDropZone();
      this.showAddOptions();
    },

    callUpload() {
      this.$refs.dropzone.$refs.dropzoneElement.click();
    },

    newID() {
      return getFlowLastId(this);
    },

    successEvent: function (file) {
      // show dummy element loading untill all files are parsed and displayed
      this.dropzoneOptions.isLoading = false;

      this.dropzoneOptions.remainingFilesCount =
        this.$refs.dropzone.getQueuedFiles().length;

      var f = {
        id: this.newID(),
        name: '_report_' + file.renameFilename,
        previewElement: file.previewElement,
        previewTemplate: file.previewTemplate,
        processing: file.processing,
        lastModified: new Date().toISOString().split('.')[0] + '+00:00',
        size: file.size,
        data: {
          responseMetadata: '',
        },
        status: 'processing',
        type: file.type,
        objType: 'report',
        upload: file.upload,
        selected: false,
        loading: false,
      };

      // if in any case, the key already exists - overwrite it with the new file
      if (
        this.files.indexOf(this.files.filter((e) => e.name == f.name)[0]) != -1
      ) {
        this.$set(
          this.files,
          this.files.indexOf(this.files.filter((e) => e.name == f.name)[0]),
          f
        );
      } else this.$set(this.files, this.files.length, f);

      // if file is accepted by filestorage, call the Loadparser API
      if (file.xhr.status == 201) {
        this.parseFile(file.renameFilename);
      } else {
        this.hideLoadingIcon(f);
      }

      file.previewElement.remove();
      this.hideDropZone();

      // Start updating files
      this.changeFileUpdateInterval(1000, false);
    },

    hideLoadingIcon: function (f) {
      var callback = function (f, it) {
        var loaded = false;
        if (typeof it.$refs[f.id] !== 'undefined')
          loaded = it.$refs[f.id][0]._data.loaded;
        if (!loaded)
          setTimeout(() => {
            callback(f, it);
          }, 100);
        else {
          f.loading = false;
          return loaded;
        }
      };
      if (callback(f, this)) f.loading = false;
    },

    async exportItem(i) {
      i.loading = true;
      this.checkRefreshToken();
      const content = await this.objectsToCSV([i]);
      this.download(content);
      i.loading = false;
    },

    async exportSelectedItems() {
      this.isLoading = true;
      this.selectedItems.map((e) => (e.loading = true));
      this.checkRefreshToken();
      const content = await this.objectsToCSV(this.selectedItems);
      this.download(content);
      this.isLoading = false;
      this.selectedItems.map((e) => (e.loading = false));
    },

    objectsToCSV: async function (arr) {
      // Remove frontend keys
      let copy_arr = JSON.parse(JSON.stringify(arr));
      copy_arr.forEach((e) => {
        delete e.loading;
        delete e[this.getSqlKey('owner')];
        delete e[this.getSqlKey('created')];
        delete e[this.getSqlKey('updated')];
        delete e[this.getSqlKey('id')];
      });

      var colNames = Object.keys(copy_arr[0]);
      var colVals = copy_arr;

      // Translate keys to labels
      colNames.forEach((part, index) => {
        if (colNames[index] != this.getSqlKey('id'))
          colNames[index] = this.itemsAsObjects[colNames[index]];
      });

      // Create CSV-String from values
      let vals = colVals
        .map((row) => {
          return Object.values(row)
            .map((value) => {
              return typeof value === 'string' ? value : JSON.stringify(value);
            })
            .join(';');
        })
        .join('\n');

      // Create CSV-String from col names
      let cols = colNames.join(';') + '\n';

      return cols + vals;
    },

    download: function (content) {
      let dataStr =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
      var link = document.createElement('a');
      link.setAttribute('href', dataStr);
      link.setAttribute(
        'download',
        this.nameWithoutPrefix(this.tableName) + '.csv'
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    hasItemLink: function (e) {
      let linkKey = this.dataSchema.find((e) => e.type == 'link')['name'];
      let i = e[linkKey];
      return i.database != null && i.item != null;
    },
    goTo: function (id) {
      this.$router.push({
        path: '/',
        query: { section: 'data', database: this.database.name, item: id },
      });
    },
    goToLink: function (e) {
      let linkKey = this.dataSchema.find((e) => e.type == 'link')['name'];
      let i = e[linkKey];

      let link = window.location.origin;
      link += '/#/?section=data&database=' + encodeURIComponent(i.database);
      link += '&item=' + encodeURIComponent(i.item);
      window.open(link, '_blank');
    },
    goToCustomProfile: async function (id) {
      try {
        this.settingsIsVisible = false;
        this.isAddingNewItem = false;
        this.isCustomDetailsVisible = true;
        document.body.classList.add('modal-open');
        this.$nextTick(async () => {
          this.$refs.customDetailsRef.setLoader(true);
          if (this.isExternalDatabase) {
            this.selectedItem = this.items.find((item) => item.id == id);
            this.$refs.customDetailsRef.setCurrentItem(this.selectedItem);
            this.$refs.customDetailsRef.setLoader(false);
          } else {
            const response = await getCustomDatabaseItem(this.tableName, id);

            if (
              response.status === 200 &&
              response.data &&
              Object.keys(response.data).length
            ) {
              const indexToReplace = this.items.findIndex(
                (item) => item.id == id
              );

              if (indexToReplace !== -1) {
                this.items[indexToReplace] = response.data;
                this.selectedItem = response.data;
                this.$refs.customDetailsRef.setCurrentItem(response.data);
                this.$refs.customDetailsRef.setLoader(false);
              } else {
                throw new Error('index not found');
              }
            } else {
              throw new Error('api returned with error');
            }
          }
        });
      } catch (error) {
        this.isCustomDetailsVisible = false;
        document.body.classList.remove('modal-open');
        this.$router.push({
          path: '/',
          query: { section: 'data', database: this.database.name },
        });
      }
    },
    getFrontEndDateFormat(value) {
      var temp = new Date(parseInt(value));
      return temp.toLocaleDateString('de-DE', this.dateOptions);
    },
    getFrontendTableNameFormat(name) {
      return name.slice(name.indexOf('_') + 1);
    },

    shareItem: async function (i) {
      this.shareSetting.artefact = 'Datenbankeintrag';
      this.shareSetting.description =
        'Der Empfänger wird eine E-Mail mit dem Datenbankeintrag als Anhang empfangen.';
      this.shareSetting.attachment = await this.getItemAsBlob([i]);
      this.shareSetting.isShareModalVisible = true;
    },

    shareSelectedItems: async function () {
      this.shareSetting.artefact = 'Datenbankeinträge';
      this.shareSetting.description =
        'Der Empfänger wird eine E-Mail mit den Datenbankeinträgen als Anhang empfangen.';
      this.shareSetting.attachment = await this.getItemAsBlob(
        this.selectedItems
      );
      this.shareSetting.isShareModalVisible = true;
    },

    getItemAsBlob: async function (i) {
      const content = await this.objectsToCSV(i);
      let dataStr =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
      return fetch(dataStr)
        .then((res) => res.blob())
        .then((blob) => {
          return blob;
        });
    },

    zipSelectedFiles(files) {
      // Assign new zip object
      let zip = new JSZip();

      // Loop through the filelist to get each filename and pass each file to zip object
      for (let file of files) {
        let filename = file.name;
        zip.file(filename, file.blob);
      }

      // Generate the complete zip file
      return zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: {
          level: 9,
        },
      });
    },

    closeModal: function () {
      this.shareSetting.isShareModalVisible = false;
    },

    alertFunctionNA: function () {
      this.modalBox.title = 'Sorry...';
      this.modalBox.msg =
        'Diese Funktion befindet sich noch in der Entwicklung und steht im aktuellen Release noch nicht zur Verfügung. ';
      this.modalBox.btnCaption = 'Alles klar!';
      this.modalBox.showAfterQueueIsDone = true;
    },

    alertMaxFilesReached: function () {
      this.modalBox.title = 'Maxanzahl erreicht';
      this.modalBox.msg =
        'Sie können maximal ' + this.dropzoneOptions.maxFiles + ' hochladen!';
      this.modalBox.btnCaption = 'Alles klar!';
      this.modalBox.showAfterQueueIsDone = true;
    },

    async showEditFilter(f) {
      this.hideEditFilter();
      this.activeFilter = f;
      this.isClickOutsideDelayed = true;
      this.isEditFilterVisible = true;
      this.activeFilterId = f.id;
      setTimeout(() => {
        this.isClickOutsideDelayed = false;
      }, 300);
    },

    hideEditFilter: function () {
      if (this.isEditFilterVisible && !this.isClickOutsideDelayed) {
        const userFilter = this.getUserLevelFilterById(this.activeFilterId);
        const databaseLevelFilter = this.getDatabaseLevelFilterById(
          this.activeFilterId
        );

        if (userFilter) {
          this.updateLocalStorageOnEditFilter(userFilter);
        } else if (databaseLevelFilter) {
          this.updateLocalStorageOnEditFilter(databaseLevelFilter);
        } else {
          const localStorageFilters = this.getFiltersFromLocalStorage();
          if (
            localStorageFilters.length &&
            this.isFilterExistInLocalStorage(this.activeFilterId)
          ) {
            const filterIndex = localStorageFilters.findIndex(
              (filter) => filter.id === this.activeFilterId
            );
            localStorageFilters.splice(filterIndex, 1, this.activeFilter);
          } else {
            localStorageFilters.push(this.activeFilter);
          }
          this.setFiltersToLocalStorage(localStorageFilters);
        }

        // store filter to local storage if edited ended
        this.isEditFilterVisible = false;
        this.activeFilter = null;
      }
    },

    hideAddFilter: function () {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        // add filter in local storage - start
        if (this.activeFilter.property) {
          const filters = this.getFiltersFromLocalStorage();
          filters.push(this.activeFilter);
          this.setFiltersToLocalStorage(filters);
        }
        // add filter in local storage - end
        this.isAddFilterVisible = false;
        this.activeFilter = null;
      }
    },

    showAddFilter: function () {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        this.isAddFilterVisible = false;
        this.activeFilter = null;
        return null;
      }
      let f = {
        id: this.newID(),
        caption: null,
        property: null,
        opperand: null,
        value: null,
      };
      this.activeFilter = f;
      this.isAddFilterVisible = true;
      this.$set(this.filters, this.filters.length, f);
      this.activeFilterId = f.id;
    },
    removeEmptyFilter: function () {
      this.filters = this.filters.filter((e) => {
        if (e.property != null) return e;
        else this.activeFilterId = null;
      });
    },
    hideModalBox: function () {
      // Hide loading after user confirm errors
      this.$set(this.dropzoneOptions, 'isLoading', false);

      // Reset modal params & hide
      this.$set(this.modalBox, 'title', '');
      this.$set(this.modalBox, 'msg', []);
      this.$set(this.modalBox, 'showAfterQueueIsDone', false);
    },

    maxFileCountReached: function (file) {
      this.alertMaxFilesReached();
      this.removeFile(file);
    },

    showComparator: function () {
      this.isComparatorVisible = true;
    },

    closeComparator: function () {
      this.isComparatorVisible = false;
    },

    // Must be simplified
    showApiOptions: function (position) {
      if (position == 'left') {
        switch (this.appSettings.app) {
          case 'slp-generator':
            break;
          case 'loadparser':
          case 'edm':
          case 'default':
            break;
        }
      } else if (position == 'right') {
        switch (this.appSettings.app) {
          case 'loadparser':
          case 'edm':
          case 'default':
            break;
        }
      }
    },

    getImgUrl(pic) {
      return require('../assets/' + pic);
    },

    getZoom: function () {
      return this.zoom / 100;
    },

    refreshSession: async function () {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            // Replace user with new token
            let user = this.user;
            user.signInUserSession = session;

            // Set updated user
            Store.commit('setUser', user);

            // Set new refresh time
            this.lastTokenRefresh = Date.now();

            return session;
          }
        );
      } catch (e) {
        // Verification failed, log out
        Store.commit('setUser', null);

        return null;
      }
    },

    hideReportViewer: function () {
      this.reportViewer.isReportViewerVisible =
        !this.reportViewer.isReportViewerVisible;
    },

    checkRefreshToken: function () {
      if ((Date.now() - this.lastTokenRefresh) / 60000 > 15)
        this.refreshSession();
    },

    getNameWithoutTimestamp: function (name) {
      let regex = /^[0-9]{13}_{1}/gm;
      return name.split(regex)[1];
    },

    showMaxFilesReached: function (count) {
      this.$set(this.modalBox, 'showAfterQueueIsDone', true);
      this.$set(
        this.modalBox.msg,
        this.modalBox.msg.length,
        'Bitte wählen Sie maximal ' +
          count +
          ' Items aus, um diese Funktion auszuführen.'
      );
      this.modalBox.showAfterQueueIsDone = true;
    },

    runAction: function (id, hoverDataId = this.elOnHoverIdx) {
      this.isActionDropDownLoading = { actionID: id, itemID: hoverDataId };
      const params = `?id=${id}&modeldatabaseid=${this.database.name}&model=${
        hoverDataId ? hoverDataId : this.selectedItems[0][this.getSqlKey('id')]
      }`;
      this.runActionApi(params);
    },

    createNewAction: async function (elOnHoverIdx = this.elOnHoverIdx) {
      let id = this.newID();
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: id,
        type: 'action',
        dataType: 'custom',
        fileKey: elOnHoverIdx
          ? elOnHoverIdx
          : this.selectedItems[0][this.getSqlKey('id')],
        tableID: this.database.name,
      });

      if (rslt == 'Access Token has expired') {
        this.handleTokenExpired();
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'process-designer',
            process: id,
          },
        });
      }
    },

    handleTokenExpired: function () {
      localStorage.clear(),
        this.$router.push({
          name: 'auth',
          params: { message: 'Sitzung abgelaufen' },
        });
    },
    toggleCustomDetails: function (id, updateItems) {
      this.toggleCopyDatabaseItem(false);
      if (updateItems === true) {
        //ToDo: get only updated item using id
        this.getAllItems().then(() => {
          if (
            this.isAddingNewItem &&
            this.headersList &&
            this.headersList.length === 0 &&
            (!this.userSettings ||
              !this.userSettings.customDatabaseSchema ||
              this.userSettings.customDatabaseSchema[this.database.name] ===
                undefined ||
              this.userSettings.customDatabaseSchema[this.database.name]
                .colPosition === undefined ||
              this.userSettings.customDatabaseSchema[this.database.name]
                .colPosition.length === 0)
          ) {
            this.headersList = this.displayParamKeys();
          }
        });
      }

      this.$router.push({
        path: '/',
        query: { section: 'data', database: this.database.name },
      });

      this.isCustomDetailsVisible = false;
      this.selectedItem = null;
      document.body.classList.remove('modal-open');
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },

    displayParam(item) {
      // eslint-disable-next-line no-unused-vars
      // let { id, selected, ...displayItem } = item;
      const displayItem = JSON.parse(JSON.stringify(item));

      delete displayItem[this.getSqlKey('id')];
      delete displayItem.selected;
      let highlightItems = this.getHighlightedItems(displayItem);
      //TODO: Move this part to higlighted items function
      // Return all if nothing is highlighted

      if (Object.keys(highlightItems).length < 1) {
        const keysToRemove = [
          this.getSqlKey('id'),
          this.getSqlKey('owner'),
          this.getSqlKey('created'),
          this.getSqlKey('updated'),
          'selected',
          'loading',
        ];

        // Get layoutitems
        let layoutItems = this.database.schema
          ? JSON.parse(this.database.schema)
          : []
              .filter((e) => e.hasOwnProperty('layoutItem') && e.layoutItem)
              .map((e) => e.name);

        let copyItem = JSON.parse(JSON.stringify(displayItem));

        // Remove frontend & layout keys
        for (let k of keysToRemove.concat(layoutItems)) {
          delete copyItem[k];
        }
        copyItem = Object.fromEntries(Object.entries(copyItem).slice(0, 5));
        return copyItem;
      }
      return highlightItems;
    },

    getHighlightedItems(items) {
      const tempHighlightItems = { ...this.highlightItems };
      if (this.isCustomHighlighting) {
        Object.keys(items).forEach((el) => {
          let i = this.customHighlightedItems.find((e) => e.name == el);
          if (i != undefined && i.selected == true) {
            this.highlightItems[el] = '';
            if (this.isCorrectElementType(el, 'freecontent')) {
              tempHighlightItems[el] = items[el];
            } else {
              tempHighlightItems[el] = isObjectType(items[el])
                ? items[el].name
                : items[el];
            }
          }
          //   let totalKeys = Object.keys(items);
          // for (let i = 0; i < totalKeys.length; i++) {
          //   let item = this.customHighlightedItems.find(
          //     e => e.name == totalKeys[i]
          //   );
          //   if (
          //     item !== undefined &&
          //     JSON.parse(JSON.stringify(item)).selected === true
          //   ) {
          //     highlightItems[totalKeys[i]] = items[totalKeys[i]];
        });
      } else {
        Object.keys(items).forEach((el) => {
          let i = this.dataSchema.find((e) => e.name == el);
          if (i != undefined && i.highlight == true) {
            if (this.isCorrectElementType(el, 'freecontent')) {
              tempHighlightItems[el] = items[el];
            } else {
              tempHighlightItems[el] = isObjectType(items[el])
                ? items[el].name
                : items[el];
            }
          }
        });
      }

      return this.sortItemsAsSchemaOrder(tempHighlightItems);
    },
    sortItemsAsSchemaOrder(items) {
      // Order items
      let itemOrder = this.dataSchema.map((e) => e.name);

      return itemOrder.reduce((sorted, key) => {
        if (items.hasOwnProperty(key)) {
          sorted[key] = items[key];
        }
        return sorted;
      }, {});
      // return JSON.parse(JSON.stringify(items, itemOrder));
    },
    toggleHighlightOptions: function () {
      this.isHighlightOptionsVisible = !this.isHighlightOptionsVisible;
    },
    setItemHighlight(clickedValue) {
      this.shouldFetchDataOnHighlight(clickedValue);
      this.highlightItems = {};
      const clickedIndexIndataSchema = this.dataSchema.findIndex(
        (e) => e.name === clickedValue.name
      );
      const clickedIndexIncustomeHighlightSchema =
        this.customHighlightedItems.findIndex(
          (e) => e.name === clickedValue.name
        );
      this.dataSchema[clickedIndexIndataSchema].highlight =
        !this.dataSchema[clickedIndexIndataSchema].highlight;
      this.customHighlightedItems[
        clickedIndexIncustomeHighlightSchema
      ].selected =
        !this.customHighlightedItems[clickedIndexIncustomeHighlightSchema]
          .selected;

      this.updateHeaderData();
    },

    setHighlightItemOptions() {
      if (!this.dataSchema.some((e) => e.highlight === true)) {
        this.dataSchema.map((data, index) => {
          if (index < 10) {
            data.highlight = true;
          }
        });
        this.customHighlightedItems = this.dataSchema.map((e) => ({
          name: e.name,
          label: e.label,
          selected: e.highlight,
        }));
      } else {
        this.customHighlightedItems = this.dataSchema.map((e) => ({
          name: e.name,
          label: e.label,
          selected: e.highlight,
        }));
      }
    },

    onSetHighlightItemOptions() {
      this.getSchema();
      this.setHighlightItemOptions();
    },
    formatValues(val) {
      const datePat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}/gm;
      const datetimePat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}/gm;
      if (Array.isArray(val)) {
        return val.join(', ');
      } else if (datetimePat.test(val)) {
        return new Date(val).toLocaleString();
      } else if (datePat.test(val)) {
        return new Date(val).toLocaleString().split(',')[0];
      } else {
        return val;
      }
    },
    sortItems: function () {
      this.items.sort((item_a, item_b) => {
        // Get timestamps
        let a = item_a[this.getSqlKey('created')];
        let b = item_b[this.getSqlKey('created')];

        // Compare
        return a < b ? 1 : b < a ? -1 : 0;
      });
    },
    async saveItems(item) {
      try {
        const formdata = new FormData();
        formdata.append('value', item.status);

        await updateDatabaseItemKey(
          this.tableName,
          item.id,
          'status',
          formdata
        );
      } catch (error) {
        this.showToaster(error, 'Fehlerhaft !', 'danger');
      }
    },
    formatLabel: function (l) {
      if (l.length > 25) return l.slice(0, 25) + '...';
      else return l;
    },
    formatDate(value) {
      if (typeof value === 'string')
        return new Date(Number(value))?.toLocaleString();
      else return new Date(value)?.toLocaleString();
    },
    removeFilter: async function (id) {
      this.filters = this.filters.filter((e) => e.id != id);
      if (!this.filters.length || id === this.activeFilterId)
        this.activeFilterId = null;

      if (this.getUserLevelFilterById(id)) {
        await this.removeFilterFromUserLevel(id);
      } else if (this.getDatabaseLevelFilterById(id)) {
        await this.removeFilterFromDatabaseLevel(id);
      }
      this.removeFilterByIdFromLocalStorage(id);
    },
    toggleFileUploader: function () {
      this.$refs.uploadBtn.click();
    },
    parseFile: function () {
      var url = process.env.VUE_APP_FILE_PARSER_API;
      url += '/parse';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      let formData = new FormData();
      formData.append('database', this.activeDatabase);
      formData.append('file', this.$refs.uploadBtn.files[0]);
      fetch(url, {
        headers: myHeaders,
        body: formData,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 401) this.handleTokenExpired();
          else return response.json();
        })
        .then(() => {
          this.refreshTable();
          this.loading = false;
          this.isUploadFileVisible = false;
        })
        .catch(() => {
          this.loading = false;
          this.isUploadFileVisible = false;
        });
    },
    addFilterCaption(caption) {
      this.activeFilter.property = caption;
      this.filterDataSchema.forEach((e) => {
        if (this.getSqlKey(e.name) == this.activeFilter.property) {
          this.activeFilter.caption = e.label;

          this.activeFilter.opperand = '';
          this.activeFilter.opperandLabel = '';

          this.activeFilter.value = ['radio', 'checkbox'].includes(e.type)
            ? []
            : '';
          if (['number', 'datetime', 'radio', 'checkbox'].includes(e.type))
            this.activeFilter.type = e.type;
          else delete this.activeFilter.type;
        }
      });
    },
    isList: function (val) {
      return Array.isArray(val) && typeof val[0] !== 'string';
    },
    displayParamKeys() {
      if (this.filteredItems[0] === undefined) return;

      return Object.keys(
        this.displayParam(this.filteredItems[this.filteredItems.length - 1])
      );
    },
    handleItemsAtCreated() {
      // const state = this.$store.state.databaseItems;
      // const name = this.database.name;
      // if (state.hasOwnProperty(name)) {
      //   this.items = state[name];
      //   this.sortItems();
      //   this.isLoading = false;
      // } else {
      // this.sortItems();
      // // Show item if url has params
      // if (this.itemID && this.isActiveDB) {
      //   this.goToCustomProfile(this.itemID);
      // }
      // }

      this.sortItems();
      // Show item if url has params
      if (this.itemID && this.isActiveDB) {
        this.goToCustomProfile(this.itemID);
      }
    },
    changeView(view) {
      if (this.view !== view) {
        this.highlightedViewIcon = view;
        this.startRender = false;
        this.isLoading = true;
        this.isScrollToTopButtonVisible = false;
        this.storeDatabaseView(view);
        setTimeout(() => {
          this.isChangeViewActive = true;
          this.zoom = 70;
          this.view = view;
          this.startRender = true;

          if (view === 'list') {
            if (
              this.userSettings &&
              this.userSettings.customDatabaseSchema &&
              this.userSettings.customDatabaseSchema[this.database.name] !==
                undefined &&
              this.userSettings.customDatabaseSchema[this.database.name]
                .colPosition !== undefined &&
              this.userSettings.customDatabaseSchema[this.database.name]
                .colPosition.length !== 0
            ) {
              const header =
                this.userSettings.customDatabaseSchema[this.database.name]
                  .colPosition;

              this.headersList = header;
            } else {
              this.headersList = this.displayParamKeys();
            }
          }
        }, 200);
      }
    },
    getSchema() {
      if (!this.database.schema) return;

      const userDataSchema = JSON.parse(this.database.schema).filter(
        (e) =>
          (!e.hasOwnProperty('layoutItem') || !e.layoutItem) &&
          (this.database.sql_cdls
            ? !Object.values(JSON.parse(this.database.sql_cdls)).find(
                (key) => key === e.name
              )
            : true)
      );

      if (
        this.userSettings &&
        this.userSettings.customDatabaseSchema &&
        this.userSettings.customDatabaseSchema[this.database.name] !==
          undefined &&
        this.userSettings.customDatabaseSchema[this.database.name]
          .colPosition !== undefined &&
        this.userSettings.customDatabaseSchema[this.database.name].colPosition
          .length !== 0
      ) {
        const header =
          this.userSettings.customDatabaseSchema[this.database.name]
            .colPosition;

        const data = [...userDataSchema].sort((a, b) => {
          const indexA = header.indexOf(a.name);
          const indexB = header.indexOf(b.name);

          if (indexA === indexB) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;

          return indexA - indexB;
        });

        const finaldata = [...data].map((ele) => {
          if (header.includes(ele.name)) {
            return { ...ele, highlight: true };
          } else {
            return { ...ele, highlight: false };
          }
        });

        this.dataSchema = finaldata;
      } else {
        this.dataSchema = userDataSchema;
      }
    },
    selectFilterItemsInCustomRange(startingIndex, endingIndex) {
      this.filteredItems.forEach((filteredItem, index) =>
        index >= startingIndex && index <= endingIndex
          ? this.selectItem(filteredItem[this.getSqlKey('id')])
          : ''
      );
    },
    selectAllItemsBetweenShiftPressed(currentItemSelectedIndex, item) {
      const newItemSelectionIndex = this.filteredItems.findIndex(
        (filteredItem) =>
          filteredItem[this.getSqlKey('id')] == item[this.getSqlKey('id')]
      );

      currentItemSelectedIndex < newItemSelectionIndex
        ? this.selectFilterItemsInCustomRange(
            currentItemSelectedIndex,
            newItemSelectionIndex
          )
        : this.selectFilterItemsInCustomRange(
            newItemSelectionIndex,
            currentItemSelectedIndex
          );
    },
    async getLogs(id) {
      try {
        const response = await getLogs(id);
        if (response.status == 200) {
          const json = await response.data;

          this.logs = json;
        }
      } catch (e) {
        this.isLoading = false;
      }
    },
    getContextId(id) {
      if (id) return `${this.database.name}::${id}`;
      else return this.database.name;
    },
    async openCustomDBLogs(id) {
      setTimeout(() => {
        this.isShowupdate = true;
      }, 50);
      await this.getLogs(this.getContextId(id));
    },
    closeCustomDBLogs() {
      this.isShowupdate = false;
    },
    hideUpdateModal(event) {
      const containingElement = document.querySelector('.custom-db-log-modal');
      if (!containingElement.contains(event.target)) {
        // hide log modal, click was outside container.
        if (this.isShowupdate) this.isShowupdate = false;
      }
    },
    scrollToTopOfLoadProfileList() {
      this.$refs.customList.scrollTo({ top: 0, behavior: 'smooth' });
    },
    isSelectedItem(id) {
      return this.selectedItemIds.includes(id);
    },
    selectItem(id) {
      if (!this.isSelectedItem(id)) this.selectedItemIds.push(id);
    },
    removeSelectedFilteredItems(id) {
      const index = this.selectedItemIds.findIndex(
        (selectedId) => selectedId == id
      );
      if (index > -1) this.selectedItemIds.splice(index, 1);
    },
    toggleSeletedItem(id) {
      const index = this.selectedItemIds.findIndex(
        (selectedId) => selectedId == id
      );
      if (index > -1) {
        this.selectedItemIds.splice(index, 1);
      } else {
        this.selectedItemIds.push(id);
      }
    },
    onCustomListScrolled(event) {
      if (event.target.scrollTop > 40 && !this.isScrollToTopButtonVisible)
        this.isScrollToTopButtonVisible = true;
      if (event.target.scrollTop < 40 && this.isScrollToTopButtonVisible)
        this.isScrollToTopButtonVisible = false;
    },
    async getTableSchema() {
      try {
        const response = await getDataBaseTableSchema(this.tableName, true);
        if (response && response.status === 200 && response.data) {
          this.$store.commit('SET_DATABASE_SCHEMA', response.data);
        }
      } catch (error) {
        this.isLoading = false;
        if (error && error.hasOwnProperty('status') && error.status === 404) {
          this.toggleNotFound(true);
        }
        throw new Error(error);
      }
    },
    setCustomHighlightedItems(headerArr) {
      if (
        this.userSettings &&
        this.userSettings.customDatabaseSchema &&
        this.userSettings.customDatabaseSchema[this.database.name] !==
          undefined &&
        this.userSettings.customDatabaseSchema[this.database.name]
          .colPosition !== undefined &&
        this.userSettings.customDatabaseSchema[this.database.name].colPosition
          .length !== 0
      ) {
        const header =
          headerArr && headerArr.length > 0
            ? headerArr
            : this.userSettings.customDatabaseSchema[this.database.name]
                .colPosition;

        const data = [...this.customHighlightedItems].sort((a, b) => {
          const indexA = header.indexOf(a.name);
          const indexB = header.indexOf(b.name);

          if (indexA === indexB) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;

          return indexA - indexB;
        });

        const finaldata = [...data].map((ele) => {
          if (header.includes(ele.name)) {
            return { ...ele, selected: true };
          } else {
            return { ...ele, selected: false };
          }
        });

        this.customData = finaldata;
      } else {
        this.customData = this.customHighlightedItems;
      }
    },
    addFilterOpperand(opperand, label) {
      this.activeFilter.opperand = opperand;
      this.activeFilter.opperandLabel = label;
      this.$forceUpdate();
    },
    async storeDatabaseView(view) {
      this.debounceFunction(
        async () => {
          let modifiedDatabaseObject;
          if (this.userSettings['customDatabaseSchema'][this.database.name]) {
            modifiedDatabaseObject = {
              ...this.userSettings['customDatabaseSchema'][this.database.name],
              dbView: view,
            };
          } else {
            modifiedDatabaseObject = {
              dbView: view,
            };
          }
          const updatedUserSettings = {
            ...this.userSettings,
            customDatabaseSchema: {
              ...this.userSettings['customDatabaseSchema'],
              [this.database.name]: modifiedDatabaseObject,
            },
          };
          await this.$store.dispatch('updateUserSettings', updatedUserSettings);
        },
        1500,
        'databaseView'
      );
    },
    removeSelectedRadioOrCheckboxOption(index) {
      this.activeFilter.value.splice(index, 1);
    },

    isFilterTypeIsRadioOrCheckBox(filterType) {
      return filterType === 'radio' || filterType === 'checkbox';
    },
    async onSaveUserLevelFilter() {
      try {
        if (
          !this.userSettings?.customDatabaseSchema ||
          !this.userSettings?.customDatabaseSchema[this.database.name] ||
          !this.userSettings?.customDatabaseSchema[this.database.name].filters
        )
          this.userSettings.customDatabaseSchema = {
            ...this.userSettings.customDatabaseSchema,
            [this.database.name]: { filters: [] },
          };

        const updatedFilter = this.filters.find(
          (filter) => filter.id === this.activeFilterId
        );
        if (this.getUserLevelFilterById(this.activeFilterId)) {
          const updatedFilterIndex = this.userSettings.customDatabaseSchema[
            this.database.name
          ].filters.findIndex((filter) => filter.id === this.activeFilterId);

          this.userSettings.customDatabaseSchema[
            this.database.name
          ].filters.splice(updatedFilterIndex, 1, updatedFilter);
        } else {
          this.userSettings.customDatabaseSchema[
            this.database.name
          ].filters.push(updatedFilter);
        }
        await this.$store.dispatch('putUserSettings', {
          settings: {
            customDatabaseSchema: this.userSettings.customDatabaseSchema,
          },
        });
        this.removeFilterByIdFromLocalStorage(this.activeFilterId);
      } catch (error) {
        //
      }
    },
    async onSaveDatabaseLevelFilter() {
      try {
        const updatedFilter = this.filters.find(
          (filter) => filter.id === this.activeFilterId
        );

        if (!this.isDatabaseLevelFilters) {
          this.database.filters = JSON.stringify([]);
        }
        const databaseFilters = jsonParser(this.database.filters) ?? [];
        if (this.getDatabaseLevelFilterById(this.activeFilterId)) {
          const updatedFilterIndex = databaseFilters.findIndex(
            (filter) => filter.id === this.activeFilterId
          );

          databaseFilters.splice(updatedFilterIndex, 1, updatedFilter);
        } else {
          databaseFilters.push(updatedFilter);
        }
        const formData = new FormData();
        formData.append('value', JSON.stringify(databaseFilters));
        await updateTableSchema(
          this.user,
          this.database.name,
          formData,
          'filters'
        );
        this.$emit('setFilterToDatabaseSchema', databaseFilters);
        this.removeFilterByIdFromLocalStorage(this.activeFilterId);
      } catch (error) {
        //
      }
    },

    resetAppliedFilters() {
      this.hideEditFilter();
      const updatedFilterIndex = this.filters.findIndex(
        (filter) => filter.id === this.activeFilterId
      );
      const userLevelFilter = this.getUserLevelFilterById(this.activeFilterId);
      if (userLevelFilter) {
        this.filters.splice(
          updatedFilterIndex,
          1,
          JSON.parse(JSON.stringify(userLevelFilter))
        );
      } else {
        const databaseLevelFilter = this.getDatabaseLevelFilterById(
          this.activeFilterId
        );
        if (databaseLevelFilter) {
          this.filters.splice(updatedFilterIndex, 1, databaseLevelFilter);
        }
      }
      this.removeFilterByIdFromLocalStorage(this.activeFilterId);
    },

    onToggleFilter(filter) {
      this.hideEditFilter();
      if (filter.id === this.activeFilterId) this.activeFilterId = null;
      else this.activeFilterId = filter.id;
    },

    getDatabaseLevelFilterById(filterId) {
      if (this.isDatabaseLevelFilters)
        return JSON.parse(this.database.filters).find(
          (dbFilter) => dbFilter.id === filterId
        );
      else return;
    },
    getUserLevelFilterById(filterId) {
      if (this.isUserLevelFilters) {
        return this.userSettings.customDatabaseSchema[
          this.database.name
        ].filters.find((userFilter) => userFilter.id === filterId);
      } else return;
    },

    async removeFilterFromUserLevel(filterId) {
      try {
        if (this.isUserLevelFilters) {
          const deletedFilterIndex = this.userSettings.customDatabaseSchema[
            this.database.name
          ].filters.findIndex((filter) => filter.id === filterId);

          this.userSettings.customDatabaseSchema[
            this.database.name
          ].filters.splice(deletedFilterIndex, 1);

          await this.$store.dispatch('putUserSettings', {
            settings: {
              customDatabaseSchema: this.userSettings.customDatabaseSchema,
            },
          });
        }
      } catch (error) {
        //
      }
    },

    async removeFilterFromDatabaseLevel(filterId) {
      try {
        if (this.isDatabaseLevelFilters) {
          const databaseFilters = jsonParser(this.database.filters) ?? [];
          const deletedFilterIndex = databaseFilters.findIndex(
            (filter) => filter.id === filterId
          );
          databaseFilters.splice(deletedFilterIndex, 1);
          const formData = new FormData();
          formData.append('value', JSON.stringify(databaseFilters));
          await updateTableSchema(
            this.user,
            this.database.name,
            formData,
            'filters'
          );
          this.$emit('setFilterToDatabaseSchema', databaseFilters);
        }
      } catch (error) {
        //
      }
    },

    setFiltersToLocalStorage(filters) {
      try {
        const allFilters =
          JSON.parse(localStorage.getItem(`filters-${this.user.username}`)) ??
          {};
        localStorage.setItem(
          `filters-${this.user.username}`,
          JSON.stringify({ ...allFilters, [this.database.name]: filters })
        );
      } catch (error) {
        localStorage.setItem(
          `filters-${this.user.username}`,
          JSON.stringify({ [this.database.name]: filters })
        );
      }
    },
    getFiltersFromLocalStorage() {
      try {
        const filters =
          JSON.parse(localStorage.getItem(`filters-${this.user.username}`)) ??
          {};
        return filters[this.database.name] ? filters[this.database.name] : [];
      } catch (error) {
        return [];
      }
    },

    updateStoredFilterInState() {
      let filtersFromUserAndDatabase = [];
      if (this.isUserLevelFilters) {
        filtersFromUserAndDatabase = JSON.parse(
          JSON.stringify(
            this.userSettings.customDatabaseSchema[this.database.name].filters
          )
        );
      }
      if (this.isDatabaseLevelFilters) {
        filtersFromUserAndDatabase = [
          ...filtersFromUserAndDatabase,
          ...JSON.parse(this.database.filters),
        ];
      }
      const localStorageFilters = this.getFiltersFromLocalStorage();
      // set filters to local storage
      if (localStorageFilters.length) {
        localStorageFilters.forEach((localFilter) => {
          const storedDatabaseFilterIndex =
            filtersFromUserAndDatabase.findIndex(
              (databseFilter) => databseFilter.id === localFilter.id
            );

          if (storedDatabaseFilterIndex !== -1) {
            filtersFromUserAndDatabase.splice(
              storedDatabaseFilterIndex,
              1,
              localFilter
            );
          } else {
            filtersFromUserAndDatabase.push(localFilter);
          }
        });
      }
      this.filters = [...filtersFromUserAndDatabase];
    },

    isRemoveFilterVisible(filterId) {
      return (
        this.isUserIsDatabaseOwnerOrHaveFullAccess ||
        this.getUserLevelFilterById(filterId) ||
        (!this.getUserLevelFilterById(filterId) &&
          !this.getDatabaseLevelFilterById(filterId))
      );
    },
    sortObjectByKeys(obj) {
      return Object.keys(obj)
        .sort()
        .reduce((acc, key) => {
          acc[key] = obj[key];
          return acc;
        }, {});
    },

    compareObject(firstObject, secondObject) {
      return (
        JSON.stringify(this.sortObjectByKeys(firstObject)) ===
        JSON.stringify(this.sortObjectByKeys(secondObject))
      );
    },

    isFilterExistInLocalStorage(filterId) {
      const localStorageFilter = this.getFiltersFromLocalStorage();
      return localStorageFilter.some((filter) => filter.id === filterId);
    },

    removeFilterByIdFromLocalStorage(filterId) {
      const localStorageFilter = this.getFiltersFromLocalStorage();
      const updatedLocalStorageFilter = localStorageFilter.filter(
        (filter) => filter.id !== filterId
      );
      this.setFiltersToLocalStorage(updatedLocalStorageFilter);
    },

    updateLocalStorageOnEditFilter(databaseFilter) {
      const localStorageFilters = this.getFiltersFromLocalStorage();

      const filterIndex = localStorageFilters.findIndex(
        (filter) => filter.id === this.activeFilterId
      );

      const isBothFilterSame = this.compareObject(
        databaseFilter,
        this.activeFilter
      );
      const isFilterInLocalStorage = this.isFilterExistInLocalStorage(
        this.activeFilterId
      );
      if (!isBothFilterSame && isFilterInLocalStorage) {
        localStorageFilters.splice(filterIndex, 1, this.activeFilter);
      } else if (!isBothFilterSame && !isFilterInLocalStorage) {
        localStorageFilters.push(this.activeFilter);
      } else if (isBothFilterSame && isFilterInLocalStorage) {
        localStorageFilters.splice(filterIndex, 1);
      }
      this.setFiltersToLocalStorage(localStorageFilters);
    },

    runActionFromNewItemButton(id) {
      const params = `?id=${id}&modeldatabaseid=${this.database.name}`;
      this.isLoading = true;
      this.runActionApi(params);
    },

    async runActionApi(params) {
      try {
        const response = await runFlowById(params);
        if (response && response.status === 200 && response.data) {
          this.$set(this.htmlViewerModal, 'myHtml', response.data);
          this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', true);
          this.isActionDropDownLoading = { actionID: null, itemID: null };
          this.isLoading = false;
        }
      } catch (error) {
        let message;
        if (error && error.data && error.data.message) {
          message = error.data.message;
        } else {
          message = 'Fehler beim Ausführen des Flows';
        }
        this.showToaster(message, 'Fehlerhaft !', 'danger');
        this.isActionDropDownLoading = { actionID: null, itemID: null };
        this.$refs.customTableRef.hideDropDown();
        this.isLoading = false;
      }
    },
    getFormattedElementToFixedValue(key) {
      const decimalCount = this.getElementData(key, 'formatted_number')
        ?.settings?.toFixed;
      return decimalCount !== undefined && decimalCount !== null
        ? decimalCount
        : 2;
    },
  },
  updated() {
    if (this.startRender == true && this.isChangeViewActive) {
      this.isLoading = false;
      this.isChangeViewActive = false;
    }
  },
  destroyed() {
    this.items = [];
  },
  async created() {
    try {
      if (
        this.$route.query &&
        this.$route.query.hasOwnProperty('filter') &&
        this.$route.query.filter
      ) {
        this.activeFilterId = parseInt(this.$route.query.filter);
      }

      this.isLoading = true;
      this.lastTokenRefresh = Date.now();

      // Get database elements-schema if not exists
      if (
        !this.database.hasOwnProperty('schema') ||
        this.database.schema === null ||
        this.database.schema === undefined ||
        this.database.schema === ''
      ) {
        await this.getTableSchema();
      }

      this.getAllItems().then(() => {
        this.sortItems();
        // Show item if url has params
        if (this.itemID && this.isActiveDB) {
          this.goToCustomProfile(this.itemID);
        }

        if (
          this.userSettings &&
          this.userSettings.customDatabaseSchema &&
          this.userSettings.customDatabaseSchema[this.database.name] !==
            undefined
        ) {
          const databaseObject =
            this.userSettings.customDatabaseSchema[this.database.name];
          this.view = databaseObject.dbView ? databaseObject.dbView : 'list';
          this.highlightedViewIcon = this.view;

          if (
            databaseObject.colPosition !== undefined &&
            databaseObject.colPosition.length !== 0
          ) {
            this.headersList = databaseObject.colPosition;
          } else {
            this.headersList = this.displayParamKeys()
              ? this.displayParamKeys()
              : [];
          }
        } else {
          this.headersList = this.displayParamKeys()
            ? this.displayParamKeys()
            : [];
          this.view = 'list';
          this.highlightedViewIcon = 'list';
        }

        this.headerNameLableObject = this.itemsAsObjects;

        this.setCustomHighlightedItems();

        this.updateStoredFilterInState();
      });

      // Get schema
      this.getSchema();
      // timeout is used to show loading
      setTimeout(() => {
        this.handleItemsAtCreated();
      }, 25);

      this.setHighlightItemOptions();
    } catch (error) {
      this.isLoading = false;
    }
  },
  mounted() {
    document.body.addEventListener('click', this.hideUpdateModal);
  },
  beforeDestroy() {
    clearInterval(this.elementUpdateInterval);
    this.$store.commit('databaseItems', {
      name: this.database.name,
      items: this.items,
    });
    document.body.removeEventListener('click', this.hideUpdateModal);
  },
  watch: {
    // Toggle customProfiles
    itemID(id) {
      if (this.itemID && this.isActiveDB) this.goToCustomProfile(id);
      // When user uses browser back button
      else if (this.isActiveDB) this.toggleCustomDetails();
    },
    'items.length'() {
      this.sortItems();
    },
    'database.schema'() {
      this.getAllItems();
      this.getSchema();
      this.setHighlightItemOptions();
      this.customData = this.customHighlightedItems;
      this.headerNameLableObject = this.itemsAsObjects;
      if (
        !this.userSettings ||
        !this.userSettings.customDatabaseSchema ||
        this.userSettings.customDatabaseSchema[this.database.name] ===
          undefined ||
        this.userSettings.customDatabaseSchema[this.database.name]
          .colPosition === undefined ||
        this.userSettings.customDatabaseSchema[this.database.name].colPosition
          .length === 0
      ) {
        this.updateHeaderData();
      }
    },
    '$route.query': function (e) {
      console.log('=====>', e);
      if (e && e.hasOwnProperty('filter') && e.filter) {
        this.activeFilterId = parseInt(e.filter);
      }
    },
    // This is used if databases are rendered using v-show
    /*
    isActiveDB(bool) {
      if (bool === true) {
        this.getAllItems();
      }
    },
    */
  },
  computed: {
    ...mapGetters({
      userHasPermissionToAddFlow: 'getUserPermissionToAddFlow',
    }),
    getFilterOptions() {
      const filterData = [...this.dataSchema].filter((el) =>
        this.headersList.includes(el.name.trim())
      );
      return [
        ...filterData,
        this.defaultFilterSchema.find((el) => el.name === 'created'),
      ];
    },
    getTableHeight() {
      let height = 70;
      if (this.selectedItems && this.selectedItems.length) return height + 70;
      return height;
    },
    userSettings() {
      return this.$store.state.userSettings;
    },
    user() {
      return Store.state.user;
    },
    isActiveDB() {
      return this.activeDatabase == this.database.name;
    },
    noData() {
      return this.items.length < 1 && !this.isLoading;
    },
    isZoomVisible() {
      return !this.noData && !this.isAddOptionsVisible;
    },
    isModalVisible() {
      return (
        this.dropzoneOptions.remainingFilesCount < 1 &&
        this.modalBox.showAfterQueueIsDone
      );
    },
    appSettings() {
      return Store.state.appSettings;
    },
    timeFrameFilter() {
      return new Date().getTime() - this.filterTime;
    },
    actionList() {
      return Store.state.flows.filter(
        (e) => e.type == 'action' && e.table_id == this.database.name
      );
    },
    timeFilteredItemIds() {
      //TODO: Filter for lastModified or createdAt...
      let filteredItems = this.items.filter(
        // eslint-disable-next-line no-unused-vars
        (e) => new Date().getTime() > this.timeFrameFilter
      );
      let filteredItemIds = filteredItems.map((e) => e[this.getSqlKey('id')]);
      return filteredItemIds;
    },
    selectedItems() {
      return this.items.filter((i) =>
        this.isSelectedItem(i[this.getSqlKey('id')])
      );
    },
    selectedItemCount() {
      return this.selectedItems.length;
    },
    isItemSelected() {
      return this.selectedItemCount > 0;
    },
    allItemsSelected() {
      let selectedItems = this.items.filter((i) =>
        this.isSelectedItem(i[this.getSqlKey('id')])
      ).length;
      return selectedItems == this.items.length;
    },
    showGroupAction() {
      if (this.isNewDataTypeModalVisible) {
        return false;
      } else
        return (
          this.items.filter((i) => this.isSelectedItem(i[this.getSqlKey('id')]))
            .length > 0
        );
    },
    showNoFilterData() {
      return this.items.length > 0;
    },
    actionsDropdownHeight() {
      return 151 - this.actionList.length * 36;
    },
    tableName() {
      return this.database.name;
    },
    isSchemaWithItemLink() {
      return this.dataSchema.find((e) => e.type == 'link') != undefined;
    },
    isCustomHighlighting() {
      return this.customHighlightedItems.some((e) => e.selected == true);
    },
    itemsAsObjects() {
      let translations = {};
      this.dataSchema.forEach((e) => (translations[e.name] = e.label));
      return translations;
    },
    statusAsArray() {
      if (this.dataSchema.find((e) => e.label == 'Status') == undefined)
        return [];
      let s = this.dataSchema.find((e) => e.label == 'Status');
      return s.options.map((e) => e.label);
    },
    filterDataSchema() {
      return [...this.dataSchema, ...this.defaultFilterSchema];
    },
    filteredItems() {
      let finalItems = [...this.items];

      if (this.filters.length > 0) {
        // Get only filters that can be interpreted
        let readyFilters = [];
        for (let f of this.filters) {
          if (
            f.property &&
            f.value &&
            f.opperand &&
            f.id === this.activeFilterId
          ) {
            if (f.type == 'datetime')
              readyFilters.push({
                ...f,
                value: moment(f.value).valueOf(),
              });
            else readyFilters.push(f);
          }
        }

        if (readyFilters.length > 0) {
          let filterString = '';
          for (let f of readyFilters) {
            // Simple type filter
            if (f.opperand == '==' || f.opperand == '!=') {
              filterString +=
                'String(e["' +
                f.property +
                '"]).toLowerCase()' +
                f.opperand +
                ' "' +
                f.value +
                '".toLowerCase()' +
                ' && ';
              // filter vor Numbers
            } else if (
              f.opperand == '<' ||
              f.opperand == '<=' ||
              f.opperand == '>' ||
              f.opperand == '>='
            ) {
              filterString +=
                'e["' +
                f.property +
                '"] && ' +
                'e["' +
                f.property +
                '"] ' +
                f.opperand +
                ' "' +
                f.value +
                '"' +
                ' && ';
            } else if (f.opperand == '!.includes(') {
              if (this.isFilterTypeIsRadioOrCheckBox(f.type)) {
                f.value && f.value.length
                  ? (filterString +=
                      '!' +
                      JSON.stringify(f.value) +
                      '.some(filterValue => ' +
                      '(e["' +
                      f.property +
                      '"]).includes(filterValue))' +
                      ' &&')
                  : (filterString += 'true' + ' &&');
              } else {
                filterString +=
                  '!String(e["' +
                  f.property +
                  '"]).toLowerCase()' +
                  ".includes('" +
                  f.value +
                  "'.toLowerCase())" +
                  ' &&';
              }
            } else {
              // Filter for includes
              if (this.isFilterTypeIsRadioOrCheckBox(f.type)) {
                f.value && f.value.length
                  ? (filterString +=
                      JSON.stringify(f.value) +
                      '.some(filterValue => ' +
                      '(e["' +
                      f.property +
                      '"]).includes(filterValue))' +
                      ' &&')
                  : (filterString += 'true' + ' &&');
              } else {
                filterString +=
                  'String(e["' +
                  f.property +
                  '"]).toLowerCase()' +
                  f.opperand +
                  '"' +
                  f.value +
                  '".toLowerCase())' +
                  ' &&';
              }
            }
          }
          filterString = filterString.slice(0, filterString.length - 3);
          // eslint-disable-next-line no-unused-vars
          finalItems = [...finalItems].filter((e) => {
            if (!eval(filterString)) {
              this.removeSelectedFilteredItems(e[this.getSqlKey('id')]);
              return false;
            } else return true;
          });
        }
      }

      // if (this.pagination.isEnabled) {
      //   const Listdata = [...finalItems].slice(
      //     0,
      //     this.pagination.page * this.pagination.limit + this.pagination.limit
      //   );

      //   return Listdata;
      // }
      return finalItems;
    },
    getOperatorOption() {
      if (this.activeFilter && this.activeFilter.property) {
        return this.filterOptions.filter((operator) =>
          this.activeFilter.type
            ? operator.visibility.includes(this.activeFilter.type)
            : operator.visibility.includes('all')
        );
      }
      return [];
    },

    getRadioOrCheckboxSelctionValue() {
      if (
        this.database.schema &&
        this.isFilterTypeIsRadioOrCheckBox(this.activeFilter?.type)
      ) {
        const selectedtypeOptions = JSON.parse(this.database.schema).find(
          (field) => field.type == this.activeFilter.type
        );
        return selectedtypeOptions.options.map((option) => option.label);
      } else {
        return [];
      }
    },
    isUserIsDatabaseOwnerOrHaveFullAccess() {
      return (
        this.database.access_level === 'owner' ||
        this.database.access_level === 'full_access'
      );
    },

    isDatabaseLevelFilters() {
      return (
        this.database?.filters &&
        jsonParser(this.database.filters) &&
        jsonParser(this.database.filters).length
      );
    },
    isUserLevelFilters() {
      return (
        this.userSettings?.customDatabaseSchema?.[this.database.name]
          ?.filters &&
        this.userSettings?.customDatabaseSchema?.[this.database.name]?.filters
          ?.length
      );
    },

    isSelectedFilterChanged() {
      const updatedFilter = this.filters.find(
        (filter) => filter.id === this.activeFilterId
      );

      const databaseLevelFilter = this.getDatabaseLevelFilterById(
        this.activeFilterId
      );
      if (databaseLevelFilter) {
        return !this.compareObject(databaseLevelFilter, updatedFilter);
      }
      const userLevelFilter = this.getUserLevelFilterById(this.activeFilterId);
      if (userLevelFilter) {
        return !this.compareObject(userLevelFilter, updatedFilter);
      }
      return false;
    },

    isActiveFilterNotExistInUserOrDatabaseLevelFilter() {
      return (
        !this.getUserLevelFilterById(this.activeFilterId) &&
        !this.getDatabaseLevelFilterById(this.activeFilterId)
      );
    },

    isUserSaveFilterVisible() {
      return (
        this.activeFilterId &&
        !this.isAddFilterVisible &&
        ((this.getUserLevelFilterById(this.activeFilterId) &&
          this.isSelectedFilterChanged) ||
          this.isActiveFilterNotExistInUserOrDatabaseLevelFilter)
      );
    },

    isResetFilterVisible() {
      return (
        this.activeFilterId &&
        !this.isAddFilterVisible &&
        this.isSelectedFilterChanged
      );
    },

    isDatabaseSaveFilterVisible() {
      return (
        this.activeFilterId &&
        !this.isAddFilterVisible &&
        this.isUserIsDatabaseOwnerOrHaveFullAccess &&
        ((this.getDatabaseLevelFilterById(this.activeFilterId) &&
          this.isSelectedFilterChanged) ||
          this.isActiveFilterNotExistInUserOrDatabaseLevelFilter)
      );
    },
    userFilterSaveButtonText() {
      return this.activeFilterId &&
        this.isActiveFilterNotExistInUserOrDatabaseLevelFilter &&
        this.isUserIsDatabaseOwnerOrHaveFullAccess
        ? 'Für mich speichern'
        : 'speichern';
    },
    databaseFilterSaveButtonText() {
      return this.activeFilterId &&
        this.isActiveFilterNotExistInUserOrDatabaseLevelFilter
        ? 'Für alle speichern'
        : 'speichern';
    },
    isExternalDatabase() {
      const databaseTypesToFilter = ['PostgreSQL'];
      return databaseTypesToFilter.includes(this.database.database_type);
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasnt a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    ModalShare,
    ModalBox,
    ...components,
    CustomDetails,
    CustomDatabaseSettings,
    htmlViewer,
    KanbanBoard,
    Updates,
    CustomTable,
    GeneralDropdown,
    NumberComponent,
    removeConfirmationModal,
    ManageTimeTriggerModal,
    PageNotFound,
  },
};
</script>

<style scoped>
.custom-list-full-screen {
  padding-top: 16px;
}
.no-data {
  display: block;
  width: 500px;
  position: relative;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.options {
  margin: 29px 130px;
  height: 296px;
  cursor: pointer;
}

.no-data .option h2 {
  font-size: 24px;
  color: #444f62;
  font-weight: 500;
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  text-transform: uppercase;
  margin-bottom: 14px;
}

.no-data .option .icon {
  margin-bottom: 23px;
  margin-top: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.option.small img {
  height: 52px;
  margin-bottom: 0;
  margin-top: 0;
}

.no-data .option {
  width: 50%;
  display: inline-block;
  padding: 0 80px;
  height: 325px;
  text-align: center;
}

.left-option {
  border-right: 1px solid #d9dde2;
  float: left;
}
.left-option.single-option {
  border-right: none;
  float: none;
}

.modal-window {
  position: absolute;
  z-index: 16;
}

.board-body {
  width: 100%;

  /* i dont know why but height 100% doesnt work only min-height */
  min-height: 100%;
  height: fit-content;
  text-align: center;
  color: #5f697a;
  display: block;
  border-top: 1px solid rgb(231, 231, 232);
  background-color: #f9f9fb;
}

.dragNDropBackGround {
  cursor: pointer;
  background-image: url('../assets/img/drag-n-drop.png');
  background-size: 1100px 1118px;
  background-position: 50% 25px;
  background-repeat: no-repeat;
  overflow: hidden;
  width: 348px;
  display: inline-block;
  text-indent: -9999px;
  font-size: 0;
  line-height: 0;
  opacity: 0.95;
}

.customdropzone {
  margin-top: 39px;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizelegibility;
  width: 100%;
  transition: background-color 0.2s linear;
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  max-height: calc(99vh - 340px);
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
  height: auto;
  overflow: auto;
  padding-left: 2px;
  padding-right: 2px;
  scrollbar-width: thin;
}

.custom-data-wrap .white-space {
  width: 100%;
  height: 12px;
  display: grid;
}

.custom-data-wrap .white-space.extra-height {
  width: 100%;
  height: 65px;
  display: grid;
}
.customdropzone .white-space {
  width: 100%;
  height: 12px;
  display: grid;
}
.customdropzone .white-space.extra-height {
  width: 100%;
  height: 65px;
  display: grid;
}

.customdropzone.full-height {
  max-height: calc(94vh - (173px + 21px));
  height: auto;
}

.customdropzone.full-height.pagination-enabled {
  max-height: calc(94vh - (173px + 35px + 20px + 26px));
}

.customdropzone .dz-preview {
  display: inline-block;
  position: relative;
  width: 441px;
  height: fit-content;
  margin: 0 30px 30px 0;
  border-radius: 4px;
  -webkit-box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  background: white;
  padding-bottom: 50px;
}

.dz-message {
  color: #808ca7;
  margin-top: 35px;
}

.dz-message h2 {
  font-size: 43px;
  font-weight: 600;
  color: #808ba7;
  margin-top: 13px;
}

.dz-message p {
  font-size: 18px;
  font-weight: 100;
}

.dz-started .dz-message {
  display: none;
}

.customdropzone .dz-preview:hover {
  top: -4px;
  transform: unset;
  box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.3), 0 0 1px 0 rgba(0, 0, 0, 0.2);
}

.customdropzone .dz-preview.loading:hover {
  transform: none;
  box-shadow: none;
}

.customdropzone .dz-preview.checked {
  transform: translateY(-4px);
  -webkit-box-shadow: 0 0 0 2px #1fc281;
  box-shadow: 0 0 0 2px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
  z-index: 1;
}

.customdropzone .dz-preview.checked .dz-image .data-dz-thumbnail-bg-overlay {
  opacity: 1;
  z-index: 1 !important;
}

.customdropzone .dz-preview .dz-image {
  height: 15px;
  top: 0;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg {
  z-index: 1;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 224px;
  width: 100%;
  position: absolute;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg.loading {
  z-index: 4000;
  height: 100%;
  border-radius: 4px;
  opacity: 1;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.on-hover {
  opacity: 1;
  z-index: 1 !important;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay {
  z-index: 9;
  top: 0;
  overflow: unset;
  border-radius: 4px;
  left: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.7);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.loading {
  height: 100%;
  border-radius: 4px;
  opacity: 1;
  z-index: 1 !important;
}

.data-dz-thumbnail-bg.processing {
  background-color: mediumslateblue;
}
.data-dz-thumbnail-bg.processed {
  background-color: lightgreen;
}

.customdropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  background-size: contain;
}

.customdropzone .dz-preview .dz-image > img {
  width: 100%;
}

.customdropzone .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}

.customdropzone .dz-preview .dz-progress {
  opacity: 1;
  height: 16px;
  width: 80px;
  background: hsla(0, 0%, 100%, 0.9);
  transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.customdropzone .dz-preview .dz-details {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-weight: 300;
  font-size: 21px;
  color: #15181f;
  letter-spacing: 0.125px;
  text-transform: none;
  padding-left: 53px;
  padding-right: 53px;
  text-align: left;
  overflow: hidden;
  height: fit-content;
}

.customdropzone .tools {
  position: absolute;
  right: 17px;
  top: 15px;
  z-index: 9;
  border: 0px solid transparent;
  -webkit-transition: visibility 0s ease 450ms, -webkit-box-shadow 0.2s ease;
  -o-transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
}

.customdropzone .tools li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0 6px;
  margin: 0;
}
.customdropzone .tools li.create-new-action {
  padding-top: 10px;
  border-top: 1px solid #eee;
  margin-top: 10px;
}

.customdropzone .tools a {
  text-indent: -9999px;
}

.customdropzone a.btn-oval {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  bottom: 0;
  right: 0;
  width: 166px;
  height: 36px;
  line-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 5px;
  color: #fff;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  position: absolute;
  text-decoration: none;
  margin: 0 auto;
}

.customdropzone a.btn-oval.item-link {
  top: 105px;
}

.customdropzone a.btn-oval:hover {
  color: rgba(25, 29, 38, 0.85);
  background-color: white;
}

.view-settings .zoom {
  width: 170px;
  position: unset;
  margin-left: 0;
  margin-top: 0;
  display: inline-block;
}

.view-settings .btn {
  width: 15px;
  height: 23px;
  padding: 0;
  border: none;
}

.view-settings .btn.active {
  background-color: #f0f0f0;
  border-radius: 3px;
  border-color: #f0f0f0;
}

.view-settings .round-button {
  width: auto;
  height: auto;
  line-height: normal;
  box-shadow: none;
  background: transparent !important;
  top: unset;
  margin: 0 !important;
  padding: 0.375rem 0.75rem;
  box-sizing: border-box;
  display: inline-block;
  border-radius: 0;
}

.view-settings .settings-button-wrapper .round-button img {
  width: 20px;
}

.view-settings .settings-button-wrapper .round-button img {
  width: 20px;
}

.slider {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  height: 2px;
  position: relative;
  top: -4px;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.customdropzone .tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -868px -268px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.customdropzone .tools li > a:hover {
  opacity: 1;
}

.customdropzone .tools li.share a {
  background-position: -868px -268px;
}
.customdropzone .tools li.log a {
  background-position: -800px -470px;
}

.customdropzone .tools li.download a {
  background-position: -868px -646px;
}

.customdropzone .tools li.delete a {
  background-position: -129px -759px;
}

.custom-list-full-screen .customdropzone .tools li.icon-copy a {
  background-position: -867px -455px;
}

.tools li.dropdown-toggle a {
  background-position: -323px -754px;
  width: 22px;
}

.dropdown-toggle::after {
  content: none;
}

ul li {
  line-height: 17px;
}

li {
  display: item;
  text-align: -webkit-match-parent;
}

input.dz-filename {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: text;
  width: 323px;
}

.dz-details input.disabled {
  background: white;
}

input:focus {
  outline-width: 0;
}

.customdropzone .dz-preview.dz-file-preview:hover input:not(.disabled) {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAUGVYSWZNTQAqAAAACAACARIAAwAAAAEAAQAAh2kABAAAAAEAAAAmAAAAAAADoAEAAwAAAAEAAQAAoAIABAAAAAEAAAAZoAMABAAAAAEAAAAZAAAAAEouuUAAAAFZaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA1LjQuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CkzCJ1kAAAFgSURBVEgNxdQ9boMwFADgZxJHWbkCWzpkQZXaoVtzhFyhZ+kZuEKPkG4ZWiliydBKGThCmRPauH7As4wBFxxHtRThn/h99jOYgcey3e/DyYlvZMgoYLC6ixcphme+DA2I65g5QV6QDoDWXkIBtS558oJHcj7+zBKeBWwuQra7Q4S7wNxjaqSQm4psZ87p0lIEP7Ni9bBc5u/pZ4wrl4HDGktxzAnRADrkMpgBZYSPRjoAylADKniRIYqDoxAL0IKoA5+DD34AUMU9zuk8lDNVNUtlIFCna9F6w/5M1zigOgNzvVbEB4BgL+IL6EV8Ap2Ib6CFXANApPGdTI78WfbRVYHjZlFftTlga6uDr3fxZfmzE4Dx1E6C0/TpGkADYcD6EOcd0KLLnbztPh5lR0Sd6ikgoeta9TlUyrtLAFtrczMBIjnPvhO6qrUxp2p1QTJYg1w1A/Fyf3vz6hTpvyf9AjOC0J5+V6YFAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: 100% 49%;
  padding-right: 20px;
  background-size: 18px;
  min-height: 42px;
}

.customdropzone .dz-preview .dz-details input {
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  position: relative;
  padding: 0 0px;
  color: #47506e;
  font-weight: 400;
  margin: 0;
}

.customdropzone .dz-preview .dz-details input {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 98%;
  box-sizing: border-box;
  margin: 0 0px 0px;
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 17px;
}

.customdropzone .dz-preview .dz-details .dz-filename.rename:hover::after {
  overflow: hidden;
  display: block;
  width: 12px;
  height: 12px;
  top: 0;
  right: 0;
  position: absolute;
  margin: 4px 10px 0 0;
  content: '';
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.checked {
  -webkit-box-shadow: 0 0 0 30px #1fc281;
  box-shadow: 0 0 0 30px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
  opacity: 1;
  z-index: 1 !important;
}

.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker {
  height: 20px;
  width: 20px;
  margin: 15px 0 0 16px;
  -webkit-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  opacity: 0.7;
  z-index: 1;
  display: block;
  line-height: 21px;
  position: relative;
  zoom: unset;
  position: relative;
}

.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker:hover {
  opacity: 1;
}

.checker input,
.checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 21px;
  width: 20px;
  display: inline-block;
  background: 0 0;
  opacity: 0;
  margin-bottom: 2%;
}

.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker
  span {
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -488px -386px;
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}
.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker
  span.checked {
  background-position: -398px -283px;
}

input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.group-actions {
  display: block;
  background: #fff;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -1px 0 rgba(76, 86, 103, 0.2),
    0 -2px 35px rgba(31, 37, 50, 0.14);
  z-index: 11;
  left: 0;
  width: 100%;
  height: 76px;
  padding: 10px 35px;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  text-align: center;
  float: left;
  clear: both;
}

.group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
}

.selected-items {
  font-size: 11px;
  border-radius: 100px;
  background: #0fbf00;
  color: #fff;
  padding: 1px 14px 0px;
  margin: 1px 6px 0 0;
  float: left;
  font-weight: 600;
}
.selected-items-label {
  float: left;
  font-size: 12px;
  color: #4a556b;
  font-weight: 600;
  text-transform: uppercase;
  float: left;
  margin: 2px 0 0 10px;
  text-rendering: optimizelegibility;
}
.group-actions .toolbar {
  margin: 3.8px 0 0 -179px;
  position: absolute;
  left: 50%;
}
.toolbar .item {
  float: left;
  margin: 0 15px;
  list-style: none;
  padding: 0;
  display: item;
  text-align: -webkit-match-parent;
}

.toolbar .item .link {
  cursor: pointer;
  top: 50%;
  display: block;
  text-indent: -9999px;
  opacity: 0.9;
  background-size: 882px 840px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: block;
  overflow: hidden;
}

.toolbar .share .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: 0 -759px;
}

.toolbar .delete .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -868px 0;
  width: 14px;
  height: 18px;
}

.toolbar .download .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}
.toolbar .more {
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
}

.toolbar .more .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -463px -759px;
  width: 18px;
  height: 4px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item {
  background: #fff;
  line-height: 36px;
  width: 100%;
  margin: 0;
  padding: 0 19px;
  margin-left: 7px;
  font-size: 14px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item.more {
  background-image: url(data:image/png;base64,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);
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.toolbar .more .toggle-list-wrapper.toggle-up {
  margin-top: -100%;
  padding: 25px 0px 25px 0px;
  min-width: 195px;
  left: 0;
  top: 0;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item:hover {
  background-color: #f0f0f0;
}

.select-all-wrapper {
  float: right;
  margin-right: 100px;
  margin-top: -11px;
}
.btn-select-all {
  background-color: white;
  border-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  margin: 12.5px;
}
.btn-select-all:focus {
  outline: none;
}

.add-new-button-wrapper {
  position: relative;
  height: 140px;
  z-index: 3;
  width: 100%;
}

.add-new-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 6px;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 114px;
  line-height: 59px;
  font-size: 23px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  position: unset;
  top: 15px;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  float: right;
  margin-top: 45px;
  margin-right: 4px;
}
.add-new-button i.fas.fa-chevron-down.btn {
  border: none;
}
.add-new-button .btn {
  color: white;
  font-size: 18px;
  opacity: 0.5;
  padding: 8px;
  padding-right: 0px;
}

.add-new-button .btn:hover {
  opacity: 1;
}

.add-new-button-wrapper .dropdown-list-open {
  position: absolute;
  right: 0px;
  box-sizing: border-box;
  padding: 20px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);
  border-radius: 4px;
  margin-top: -86px;
  z-index: 10;
  text-align: center;
  cursor: pointer;
}

.round-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 60px;
  line-height: 59px;
  font-size: 30px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  position: relative;
  top: -33px;
  transition: transform 0.2s ease-in-out;
}

.round-button.settings {
  background-color: white;
  color: clack;
  font-size: 19px;
  display: inline-block;
  margin-right: 7px;
  padding-right: 0;
}

.round-button.refresh {
  background-color: white;
  color: clack;
  font-size: 19px;
  display: inline-block;
  margin-right: 7px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}

.round-button img {
  width: 30px;
}

.round-button-wrapper.clicked .round-button {
  transform: rotate(45deg);
}

.round-button:hover {
  transform: scale(1.1) rotate(0);
}

.add-new-button:hover {
  transform: scale(1.1) rotate(0);
}

.round-button-wrapper.clicked .round-button:hover {
  transform: scale(1.1) rotate(45deg);
}

.plus-btn-options {
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  background-color: #ffff;
  bottom: unset;
  margin-top: -12px;
  margin-bottom: unset;
  margin-right: 32px;
  margin-left: -331px;
}

.plus-btn-options .option {
  text-align: center;
  display: inline-block;
  padding: 47px 15px 45px;
  border-right: solid 1px #dbdee5;
  cursor: pointer;
  width: 165px;
}

.file-icon {
  background-image: url('../assets/img/slp-chart.png');
  background-size: 882px 840px;

  background-repeat: no-repeat;
  overflow: hidden;
  display: block;

  cursor: pointer;
  margin: 0 auto;
  height: 64px;
}

.plus-btn-options .option h2 {
  font: 600 15px/22px brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  color: #434c5e;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
}

.option p {
  font-size: 13px;
  line-height: 22px;
  margin: 0;
  padding: 0;
  font-family: inherit;
  text-rendering: optimizelegibility;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #8d8b8b;
  height: auto;
}

.file {
  background-position: -712px 9px;
  width: 38px;
}

.accessibility {
  left: 64px;
}

.data-dz-thumbnail-bg-overlay .loading .progress-icon {
  display: block;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: translateY(-50%);
}

.progress-icon.dark-color {
  margin: auto;
}

.progress-icon.dark-color.center {
  left: auto;
}

.progress-icon.dark-color.table-loader {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}

.progress-icon.dark-color:after {
  border-color: #1f2532 transparent #1f2532 transparent;
  width: 100px;
  height: 100px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.dot-flashing {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #797f89;
  color: #c4c2cb;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #797f89;
  color: #c4c2cb;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #797f89;
  color: #c4c2cb;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: #797f89;
  }
  50%,
  100% {
    background-color: #c4c2cb;
  }
}

.status-icon {
  position: relative;
  left: 50%;
  top: 123px;
}

.data-dz-thumbnail-bg-overlay p {
  color: white;
  font-size: 14px;
  display: block;
  margin-top: 99px;
}

.status-img img {
  width: 88px;
  margin-top: 82px;
  opacity: 0.5;
}

input.rename::placeholder {
  color: #a0a4ad;
  font-style: inherit;
}

.show-on-hover {
  visibility: hidden;
  height: 0px;
}

.hide-on-hover {
  visibility: visible;
  height: 23px;
}

.customdropzone .dz-preview:hover .show-on-hover {
  visibility: visible;
  height: 23px;
}

.customdropzone .dz-preview:hover .hide-on-hover {
  visibility: hidden;
  height: 0px;
}

.file-filter {
  float: left;
  margin-left: 9%;
  width: fit-content;
}

.file-filter select {
  border: none;
  outline: none;
  background: white;
}

.menu3-bar {
  font-size: 12px;
  position: relative;
  text-align: left;
}

.menu3-bar i {
  font-size: 25px;
  cursor: pointer;
}

.menu3-bar .item {
  margin: 0 46px 0 0;
  vertical-align: top;
  display: inline-block;
  line-height: 57px;
  cursor: pointer;
}

.menu3-bar .item.active {
  border-bottom: solid 2px rgb(255, 51, 102);
  color: rgb(247 58 105);
  background: none;
}

::v-deep .menu3-bar .toggle-list-wrapper.toggle-down {
  position: absolute;
  left: 20px;
  top: 80px;
  width: 200px;
  z-index: 15;
  padding-right: 0;
  height: 450px;
  padding: 0;
  overflow: auto;
}

.menu3-bar .toggle-list-wrapper.toggle-down .item {
  margin: 0;
  padding-left: 25px;
  width: 100%;
}

.menu3-bar .toggle-list-wrapper.toggle-down .item .highlight-checkbox {
  position: absolute;
  right: -30px;
  top: 25px;
}

.menu3-bar .toggle-list-wrapper.toggle-down .item.selected {
  background: #f0f0f0;
}

.menu3-bar .item.more.highlight {
  margin-left: 45px;
}

.menu3-bar .item.more .dropdown-toggle .link.dropdown-toggle {
  color: black;
}

.toggle-list-wrapper.toggle-up.toggle-right {
  position: absolute;
  left: 230px !important;
}
.dz-no-content-message {
  width: 100%;
  text-align: center;
  color: #6b7482;
  font-weight: 300;
}

.dz-no-content-message img.no-data {
  position: inherit;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  width: 278px;
  cursor: pointer;
}

.dz-no-content-message img.no-data.default-cursor {
  cursor: default;
}

.dz-no-content-message h3 {
  font-size: 23px;
  font-weight: 300;
}

.dz-details .highlighted-item {
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dz-details .highlighted-item.first {
  font-size: 25px;
  font-weight: 400;
}

.filter-icon {
  background-image: url('../assets/img/filter.svg');
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  cursor: pointer;
}

.key-filter {
  /* width: 1300px; */
  font-size: 25px;
  padding-left: 0px;
}

.filter.dropdown select,
input {
  border: none;
  display: inline-block;
  height: 26px;
  width: 119px;
  color: #000;
  font-size: 14px;
  text-align: center;
}

.filter.dropdown.edit ::v-deep .dropdown .btn {
  width: fit-content;
}

.menu3-bar .filter.dropdown select,
.menu3-bar input {
  height: 36px;
  padding: 6px 12px;
}

.filter.dropdown.edit select,
input {
  display: block;
  border-radius: 3px;
  text-align: left;
}

.filter.dropdown.edit input {
  border: 1px solid #9398a3;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.filter.dropdown.add select,
input {
  display: inline-block;
}

.filter.dropdown.upload {
  width: 290px;
  padding: 15px 0;
  right: 0;
  top: 200px;
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  cursor: pointer;
}

.key-filter select:focus {
  outline-width: 0;
}

.key-filter input:focus {
  outline-width: 0;
}

.key-filter .filter .tools i {
  font-size: 15px !important;
}

.kanban-board-wrapper {
  overflow: scroll;
  width: 100%;
  height: 100vh;
}

.filter-item-wrapper {
  display: flex;
  vertical-align: top;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
}

.filter.dropdown.edit {
  position: fixed;
  display: block;
  margin-top: 12px;
  margin-left: -20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.filter-item {
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform;
  transition-timing-function: var(--hds-beziers-in-out);
  transition-duration: 0.15s;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.03px;
  font-weight: 400;
  border: solid 1px #787d87;
  width: fit-content;
  min-width: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
  display: inline-block;
  margin-right: 9px;
  color: black;
  font-weight: 200;
  cursor: pointer;
  padding-bottom: 7px;
  padding-top: 7px;
}

.filter-item i {
  width: 0;
  opacity: 0;
}

.filter-item:hover {
  background-color: #f2f2f2;
}

.filter-item:hover i {
  width: 10px;
  opacity: 1;
  font-size: 11px;
  margin-left: 16px;
  color: #4f4f54;
}

.filter-item i.fa-caret-down {
  font-size: 15px;
  opacity: 1;
  width: 10px;
  margin-left: 16px;
}

.filter-item:hover i:hover {
  color: black;
}

.filter.dropdown {
  background-color: white;
  padding: 30px;
  -webkit-box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  border-radius: 9px;
  position: absolute;
  z-index: 10;
  margin-left: 0;
}

.filter.dropdown.add {
  top: 30px;
}
.filter.dropdown.edit {
  padding: 5px;
}

.filter.dropdown hr {
  margin-top: 3px;
  background-color: #f0ebeb;
}

.filter.dropdown h2 {
  font-weight: 300;
  font-size: 22px;
  margin-bottom: 26px;
}

.filter.dropdown select {
  background: white;
}

.custom-data-wrap .dz-preview .dz-details {
  line-height: 60px;
  width: 100%;
  height: 60px;
  display: table-row;
  font-size: 15px;
  margin: 0;
  text-align: center;
  box-sizing: border-box;
}

.custom-data-wrap .dz-preview .dz-details > div {
  min-width: 225px;
  width: 225px;
  padding-left: 22px;
  margin-left: 36px;
  line-height: 60px;
  position: relative;
  display: inline-table;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  display: table-cell;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  background: #fff;
}
.custom-data-wrap {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  height: 100%;
}

.custom-data-wrap.full-height {
  height: calc(98vh - 150px);
}
.data-header .dz-data-wrap {
  width: 100%;
  display: table-row;
  position: relative;
}

.data-header .dz-data-wrap .dz-data {
  line-height: 60px;
  width: 100%;
  height: 60px;
  display: table-row;
  font-size: 15px;
  margin: 0;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.data-header .dz-data-wrap .dz-data div {
  min-width: 225px;
  max-width: 225px;
  width: 225px;
  padding-left: 22px;
  margin-left: 36px;
  line-height: 60px;
  position: relative;
  display: inline-table;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  display: table-cell;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.custom-data-wrap .dz-preview.list {
  display: table;
  overflow: unset;
  margin-left: 0;
  margin-right: 0;
}

.custom-data-wrap .dz-preview .dz-details > div.highlighted-item.first {
  font-size: 17px;
  color: #47506e;
  font-weight: 400;
}

.custom-data-wrap .dz-preview .dz-details > div.highlighted-item {
  font-size: 15px;
  color: #5f697a;
}
.custom-data-wrap .dz-preview.dz-file-preview.list input[type='checkbox'] {
  opacity: 1;
}

.custom-data-wrap .list .checker input,
.custom-data-wrap .list .checker input[type='checkbox'] {
  opacity: 1;
  accent-color: #53c08a;
  margin-right: 20px;
}

.custom-data-wrap .dz-preview:hover .checker input[type='checkbox'] {
  margin-bottom: 3%;
}

.custom-data-wrap .data-header {
  position: sticky;
  top: 0;
  background: #f9f9fb;
  display: table;
  width: 100%;
  zoom: 0.7;
  margin-bottom: 6px;
  margin-left: -6px;
  padding-left: 11px;
  padding-right: 10px;
}

.custom-data-wrap .data-header .dz-data-wrap .dz-data > div:first-child {
  max-width: 90px;
  padding-left: 0;
  width: 90px;
  min-width: 90px;
}

.custom-data-wrap .dz-preview .dz-details > div.checker {
  max-width: 90px;
  width: 90px;
  min-width: 90px;
}

.btn-oval {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translate(-30%, -50%);
  right: 140px;
  display: block;
  transition: all 400ms ease-in-out;
  opacity: 0;
  visibility: hidden;
}

.btn-oval a {
  color: #4c5572;
  opacity: 1;
  background-color: #ffff;
  border: 1px solid #ccc;
  border-radius: 4px 4px 4px 4px;
  padding: 7px 23px;
  min-width: 70px;
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  height: auto;
  width: auto;
  line-height: 24px;
}

.custom-data-wrap .dz-preview:hover .btn-oval {
  transform: translate(0, -50%);
  opacity: 1;
  visibility: visible;
  background: #fff;
  padding-top: 0px;
  padding-bottom: 1px;
  z-index: 3;
}

.custom-data-wrap .dz-preview:hover .btn-oval.move-left {
  right: 112px;
}

.custom-data-wrap .dz-preview:hover .tools {
  background: #fff;
  margin-top: -1px;
}

.custom-data-wrap .dz-preview:hover .tools li > a {
  -webkit-filter: brightness(14%);
  filter: brightness(14%);
}

.custom-data-wrap .dz-preview .tools {
  top: 50%;
  transform: translateY(-50%);
  margin-bottom: 0;
  padding-left: 0;
}

.dz-detail-wrap {
  width: 100%;
  display: table-row;
  position: relative;
}

.data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 172px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.custom-loader.show {
  opacity: 1 !important;
}

.custom-loader {
  height: 100%;
  z-index: 5;
}

.data-dz-thumbnail-bg-overlay.custom-loader:hover {
  opacity: 0;
}

.loading .progress-icon {
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  height: auto;
  position: absolute;
  width: auto;
  text-align: center;
}

.loading .progress-icon:after {
  margin: 0 auto;
}

.custom-loader + .header {
  position: relative;
  z-index: 2;
}

.show-overlay:before {
  opacity: 1;
  visibility: visible;
}

.custom-data-wrap > div.checked[index='1'] {
  margin-top: 10px;
}

.dz-details .highlighted-item > div {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.custom-data-wrap .dz-preview.list .dz-details .highlighted-item > div {
  max-width: 203px;
}

.custom-data-wrap .data-header > div {
  text-align: left;
}

.custom-data-wrap .dz-preview.list .dz-details .highlighted-item > div {
  text-align: left;
}

.drag-inner-list {
  padding: 1px;
}

.overlay-checkbox .data-dz-thumbnail-bg-overlay.checked {
  background-color: rgba(25, 29, 38, 0.7);
}

.list .data-dz-thumbnail-bg-overlay .progress-icon:after {
  width: 39px;
  height: 39px;
  border: 3px solid #fff;
  border-color: #fff transparent #fff transparent;
}

.dz-preview.dz-file-preview.loading .tools,
.dz-preview.dz-file-preview.loading .checker,
.dz-preview.dz-file-preview.loading .btn-oval {
  display: none !important;
}
.dz-preview.dz-file-preview.loading .progress-icon {
  z-index: 6;
}

.h-full {
  box-sizing: border-box;
  min-height: calc(100vh - 80px);
  position: relative;
}

.customdropzone .dz-preview .toggle-list-wrapper {
  background: transparent;
  box-shadow: none;
  width: auto;
  padding: 0;
  top: unset;
  left: unset;
  margin-top: 0;
  padding: 0;
  overflow: unset;
}

.customdropzone .dz-preview .toggle-list-wrapper .item.more {
  width: 0;
  padding: 7px 21px;
  position: relative;
  left: -10px;
}

.customdropzone .dz-preview .toggle-list-wrapper .item.more:hover {
  background-color: transparent;
}

.options-more {
  color: rgb(255 255 255 / 60%);
}

/* Action dropdown basic style */
.dropdown.action-dropdown {
  display: contents;
  height: 100%;
}

.dropdown.action-dropdown ul {
  position: absolute;
  right: 0;
  background: #fff;
  text-align: left;
  margin-right: 26px;
  z-index: 3;
  width: 255px;
  display: grid;
  overflow-y: auto;
  list-style: none;
  padding-left: 0;
  border: solid 0.1px #f0f0f0;
  border-radius: 4px;
  top: 37px;
}

.dropdown.action-dropdown li {
  line-height: 1.5;
  font-size: 16px;
  cursor: pointer;
  padding: 15px 25px;
}

.dropdown.action-dropdown li:hover {
  background: #f0f0f0;
}

.dropdown.action-dropdown ul::-webkit-scrollbar-thumb {
  background: #b8b8b8;
  border-radius: 0px;
}

.dropdown.action-dropdown ul::-webkit-scrollbar-thumb:hover {
  background: #959595;
}

/* Action dropdown list-view style */
.dropdown.action-dropdown.list-view ul {
  max-height: 300px;
}

/* Action dropdown icon-view style */
.customdropzone .dropdown.action-dropdown.icon-view ul {
  max-height: calc(100% - 46px);
}

.create-new-action {
  min-height: 25px;
  line-height: 1.5;
  font-size: 16px;
  margin-top: 5px;
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 5px 11px;
  margin: 0;
  display: list-item;
  padding-top: 10px;
  border-top: 1px solid #eee;
  z-index: 1000;
}

.create-new-action:hover {
  background: #f0f0f0;
}

.dropdown-open .dz-preview.dz-file-preview.list {
  z-index: unset !important;
  transform: none !important;
}

.list-view-dropdown-toggle {
  display: grid;
  max-height: 300px;
  overflow: auto;
}

.create-new-action i {
  margin-right: 10px;
}
.listview-wrapper {
  padding: 0 3px;
  overflow: auto;
  height: calc(100vh - 358px);
}

.custom-list-full-screen .go-to-top {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 12;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: #1f2532;
  cursor: pointer;
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 50px;
  opacity: 0;
  transform: translateY(100px);
  animation-name: scrollButtonUp;
  animation-duration: 0.5s;
  animation-direction: alternate;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-list-full-screen .go-to-top span {
  background-image: url(/img/project-sprite.1c2e7465.png);
  background-position: -1600px -1204px;
  width: 32px;
  height: 35px;
  display: block;
  background-repeat: no-repeat;
  overflow: hidden;
  zoom: 0.7;
  filter: brightness(100);
}
@keyframes scrollButtonUp {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/*Action Topbar*/
.action-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.action-top-bar .view-settings {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.action-top-bar .list-view-icon {
  display: inline-block;
  padding: 6px 12px;
  margin-left: 2px;
}

.action-top-bar .list-view-icon.active {
  background-color: #f0f0f0;
  border-radius: 3px;
  border: 1px solid #727c8c;
}

.action-top-bar .action-top-bar-left .menu3-bar .list-item ul {
  margin-bottom: 0;
}

.custom-database-list .action-top-bar-left {
  width: 50%;
}

.is-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.customdropzone.customdropzone-icon-view {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.customdropzone-icon-view .list .object-list-icon {
  width: 30px;
  height: 30px;
  margin-left: 15px;
}
.listview-wrapper .list .object-list-icon {
  width: 30px;
  height: 30px;
}
.filter.dropdown input[type='datetime-local'] {
  width: 160px;
}

.listwrapper .actioncontainer ul .dropdown-btn {
  cursor: pointer;
  transition: all 200ms ease-in-out;
  opacity: 0.6;
  width: 18px;
  margin-top: -2px;
}

.listwrapper .actioncontainer ul i {
  cursor: pointer;
  color: #5f697a;
  transition: all 200ms ease-in-out;
}

.listwrapper .actioncontainer ul i:hover {
  color: #2a2e35;
}

.listwrapper .actioncontainer ul li.show-btn {
  transition: all 400ms ease-in-out;
  /* transform: translateX(-50px); */
}

.listwrapper .actioncontainer ul li.show-btn a {
  display: block;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 8px;
  min-width: 95px;
  text-align: center;
  color: #5f697a;
  text-transform: uppercase;
  font-size: 10px;
  cursor: pointer;
  text-decoration: none;
}

.listwrapper .actioncontainer ul li.show-btn a:hover {
  color: #2a2e35;
}

.group-action-open {
  bottom: 80px !important;
}

.listwrapper .load-more {
  text-align: left;
  padding: 4px 0 10px;
  position: sticky;
  left: 0;
}

.custom-list-full-screen .load-more button {
  background: transparent;
  border: none;
  color: #555555;
  padding: 7px 10px;
  font-size: 14px;
  -webkit-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.custom-list-full-screen .load-more button:hover {
  color: #555555;
  background: #dfdfdf80;
  color: black;
}
.customdropzone.customdropzone-icon-view {
  padding-top: 4px;
}
.custom-list-full-screen
  .filter-item-wrapper
  .filter-item
  .filter.dropdown.edit {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.custom-list
  .filter-item-wrapper
  .filter-item
  .filter.dropdown.edit
  .filter-input {
  margin-top: 0;
}
.custom-list
  .filter-item-wrapper
  .filter-item
  .filter.dropdown.edit
  ::v-deep
  .dropdown-component {
  min-width: 119px;
}
.custom-list
  .customdropzone
  .dz-preview
  .action-dropdown.icon-view
  ul
  .dropdown-action-item,
.custom-list-full-screen
  .listwrapper
  .actioncontainer
  ul
  .dropdown-action-item {
  position: relative;
}
.custom-list
  .customdropzone
  .dz-preview
  .action-dropdown.icon-view
  ul
  .loadingoverlay,
.custom-list-full-screen .listwrapper .actioncontainer ul .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f2532c7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  text-align: center;
}
.custom-list
  .customdropzone
  .dz-preview
  .action-dropdown.icon-view
  ul
  .loadingoverlay
  .custom-table-progress-icon,
.custom-list
  .listwrapper
  .actioncontainer
  ul
  .loadingoverlay
  .custom-table-progress-icon,
.custom-list-full-screen .load-more .custom-table-progress-icon {
  content: ' ';
  display: block;
  width: 30px;
  height: 30px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
  /* top: 5px; */
  position: absolute;
  left: 45%;
}

.custom-list-full-screen .load-more .custom-table-progress-icon {
  width: 20px;
  height: 20px;
  border: 1px solid #555555;
  border-color: #555555 transparent #555555 transparent;
  position: unset;
  margin-left: 10px;
}
.custom-list
  .customdropzone
  .dz-preview
  .action-dropdown.icon-view
  ul
  .loadingoverlay
  .custom-table-progress-icon {
  zoom: 1.3;
  border: 3px solid #fff;
  border-color: #fff transparent #fff transparent;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}

.custom-list-full-screen .filter-checkbox-wrap ::v-deep .custom-checkbox {
  display: flex;
  padding: 0 10px;
  align-items: center;
}

.custom-list
  .filter-checkbox-wrap
  ::v-deep
  .custom-checkbox
  .custom-control-input {
  width: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 10px;
}
.custom-list-full-screen .filter-checkbox-wrap ::v-deep .custom-checkbox label {
  cursor: pointer;
}
.custom-list-full-screen .selected-filter-options-wrap {
  display: flex;
  font-size: 12px;
  gap: 4px;
}

.custom-list-full-screen
  .selected-filter-options-wrap
  .selected-filter-options {
  background: #eee;
  border-radius: 4px;
  padding: 4px 10px;
  margin-bottom: 4px;
}

.custom-list-full-screen
  .selected-filter-options-wrap
  .selected-filter-options
  i {
  font-size: 12px;
  margin-left: 10px;
  display: none;
}
.custom-list-full-screen
  .selected-filter-options-wrap
  .selected-filter-options:hover
  i {
  display: inline-block;
}
.custom-list-full-screen .filter-item:has(.edit):hover i.fa-trash {
  display: none !important;
}

.custom-list-full-screen .filter-item .filter-checkbox {
  width: 15px;
  height: 20px;
  margin: 0 4px 0 0 !important;
  cursor: pointer;
  accent-color: black;
}
.custom-list-full-screen .black-btn {
  border: 1px solid #787d87;
  border-radius: 5px;
  padding: 0 18px 0px;
  background: transparent;
  color: black;
  text-transform: capitalize;
  transition: all 300ms ease-in-out;
  font-size: 12px;
  display: flex;
  align-items: center;
  line-height: normal;
  height: 37px;
}

.custom-list-full-screen .black-btn:hover {
  background: black;
  color: white;
}
.custom-list-full-screen .black-btn[disabled='disabled'] {
  opacity: 0.3;
  pointer-events: none;
}
.custom-list-full-screen .filter-list-main-wrap {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.custom-list-full-screen .filter-list-main-wrap .filter-item-wrapper {
  width: calc(100% - 450px);
}

.custom-list-full-screen .filter-list-main-wrap .filter-action-buttons {
  width: 450px;
  display: flex;
  justify-content: flex-end;
}

.custom-list-full-screen .option-wrap {
  display: flex;
  align-items: center;
  text-align: left;
  padding: 15px 20px;
}

.custom-list-full-screen .option-wrap .option-btn-content-wrap h2 {
  margin-bottom: 0 !important;
  font: 600 15px/22px brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  color: #434c5e;
  text-transform: uppercase;
  margin-top: 0;
}

.custom-list-full-screen .option-wrap .option-btn-content-wrap {
  padding-left: 22px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.custom-list-full-screen .scroller::-webkit-scrollbar-track {
  background-color: #ddd;
}

.custom-list-full-screen .scroller::-webkit-scrollbar-thumb {
  background-color: #1f2532;
}
.custom-list-full-screen .database-flowlist-wrap .database-flowlist-item {
  padding: 14px 20px;
  border-bottom: solid 1px #dbdee5;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}
.custom-list-full-screen
  .database-flowlist-wrap
  .database-flowlist-item:last-child {
  border-bottom: none;
}
.custom-list-full-screen
  .database-flowlist-wrap
  .database-flowlist-item:first-child {
  border-top: solid 1px #dbdee5;
}
.custom-list-full-screen .database-flowlist-wrap {
  max-height: 144px;
  overflow-y: auto;
}
</style>
